// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "reports.proto" (syntax proto3)
// tslint:disable
// @generated by protobuf-ts 2.11.1 with parameter output_javascript
// @generated from protobuf file "reports.proto" (syntax proto3)
// tslint:disable
import { Bool } from "./common";
import { Empty } from "./common";
import { Event } from "./event";
import { String$ } from "./common";
import { Int32 } from "./common";
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { WireType } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { TimeoffRequestList } from "./timesheet_line";
import { DateRange } from "./common";
// @generated message type with reflection information, may provide speed optimized methods
class SpiffReportLine$Type extends MessageType {
    constructor() {
        super("SpiffReportLine", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "employee_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "contract_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "status_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "timestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "pay_year", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "pay_month", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "pay_week", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "is_paid_weekly", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "is_paid_monthly", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "is_active", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 21, name: "employee_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "ext", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.employeeId = 0;
        message.eventId = 0;
        message.contractId = 0;
        message.typeId = 0;
        message.statusId = 0;
        message.category = "";
        message.description = "";
        message.amount = 0;
        message.timestamp = "";
        message.payYear = 0;
        message.payMonth = 0;
        message.payWeek = 0;
        message.isPaidWeekly = false;
        message.isPaidMonthly = false;
        message.isActive = false;
        message.employeeName = "";
        message.address = "";
        message.jobNumber = "";
        message.ext = "";
        message.orderBy = "";
        message.orderDir = "";
        message.dateTarget = [];
        message.dateRange = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 employee_id */ 2:
                    message.employeeId = reader.int32();
                    break;
                case /* int32 event_id */ 3:
                    message.eventId = reader.int32();
                    break;
                case /* int32 contract_id */ 4:
                    message.contractId = reader.int32();
                    break;
                case /* int32 type_id */ 5:
                    message.typeId = reader.int32();
                    break;
                case /* int32 status_id */ 6:
                    message.statusId = reader.int32();
                    break;
                case /* string category */ 7:
                    message.category = reader.string();
                    break;
                case /* string description */ 8:
                    message.description = reader.string();
                    break;
                case /* double amount */ 9:
                    message.amount = reader.double();
                    break;
                case /* string timestamp */ 10:
                    message.timestamp = reader.string();
                    break;
                case /* int32 pay_year */ 11:
                    message.payYear = reader.int32();
                    break;
                case /* int32 pay_month */ 12:
                    message.payMonth = reader.int32();
                    break;
                case /* int32 pay_week */ 13:
                    message.payWeek = reader.int32();
                    break;
                case /* bool is_paid_weekly */ 14:
                    message.isPaidWeekly = reader.bool();
                    break;
                case /* bool is_paid_monthly */ 15:
                    message.isPaidMonthly = reader.bool();
                    break;
                case /* bool is_active */ 16:
                    message.isActive = reader.bool();
                    break;
                case /* string employee_name */ 21:
                    message.employeeName = reader.string();
                    break;
                case /* string address */ 22:
                    message.address = reader.string();
                    break;
                case /* string job_number */ 23:
                    message.jobNumber = reader.string();
                    break;
                case /* string ext */ 24:
                    message.ext = reader.string();
                    break;
                case /* string order_by */ 17:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 18:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string date_target */ 20:
                    message.dateTarget.push(reader.string());
                    break;
                case /* repeated string date_range */ 19:
                    message.dateRange.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 employee_id = 2; */
        if (message.employeeId !== 0)
            writer.tag(2, WireType.Varint).int32(message.employeeId);
        /* int32 event_id = 3; */
        if (message.eventId !== 0)
            writer.tag(3, WireType.Varint).int32(message.eventId);
        /* int32 contract_id = 4; */
        if (message.contractId !== 0)
            writer.tag(4, WireType.Varint).int32(message.contractId);
        /* int32 type_id = 5; */
        if (message.typeId !== 0)
            writer.tag(5, WireType.Varint).int32(message.typeId);
        /* int32 status_id = 6; */
        if (message.statusId !== 0)
            writer.tag(6, WireType.Varint).int32(message.statusId);
        /* string category = 7; */
        if (message.category !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.category);
        /* string description = 8; */
        if (message.description !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.description);
        /* double amount = 9; */
        if (message.amount !== 0)
            writer.tag(9, WireType.Bit64).double(message.amount);
        /* string timestamp = 10; */
        if (message.timestamp !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.timestamp);
        /* int32 pay_year = 11; */
        if (message.payYear !== 0)
            writer.tag(11, WireType.Varint).int32(message.payYear);
        /* int32 pay_month = 12; */
        if (message.payMonth !== 0)
            writer.tag(12, WireType.Varint).int32(message.payMonth);
        /* int32 pay_week = 13; */
        if (message.payWeek !== 0)
            writer.tag(13, WireType.Varint).int32(message.payWeek);
        /* bool is_paid_weekly = 14; */
        if (message.isPaidWeekly !== false)
            writer.tag(14, WireType.Varint).bool(message.isPaidWeekly);
        /* bool is_paid_monthly = 15; */
        if (message.isPaidMonthly !== false)
            writer.tag(15, WireType.Varint).bool(message.isPaidMonthly);
        /* bool is_active = 16; */
        if (message.isActive !== false)
            writer.tag(16, WireType.Varint).bool(message.isActive);
        /* string order_by = 17; */
        if (message.orderBy !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 18; */
        if (message.orderDir !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string date_range = 19; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(19, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 20; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(20, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* string employee_name = 21; */
        if (message.employeeName !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.employeeName);
        /* string address = 22; */
        if (message.address !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.address);
        /* string job_number = 23; */
        if (message.jobNumber !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.jobNumber);
        /* string ext = 24; */
        if (message.ext !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.ext);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SpiffReportLine
 */
export const SpiffReportLine = new SpiffReportLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SpiffReport$Type extends MessageType {
    constructor() {
        super("SpiffReport", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SpiffReportLine }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SpiffReportLine data */ 1:
                    message.data.push(SpiffReportLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SpiffReportLine data = 1; */
        for (let i = 0; i < message.data.length; i++)
            SpiffReportLine.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SpiffReport
 */
export const SpiffReport = new SpiffReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromptPaymentReportLine$Type extends MessageType {
    constructor() {
        super("PromptPaymentReportLine", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "billingDate", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "due_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "payment_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "report_until", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "days_to_pay", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "user_business_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "user_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "payable", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 12, name: "payed", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "payment_terms", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "eligible_rate", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "possible_award", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 16, name: "rebate_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 17, name: "rebate_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.billingDate = "";
        message.dueDate = "";
        message.paymentDate = "";
        message.reportUntil = "";
        message.daysToPay = 0;
        message.jobNumber = "";
        message.userId = 0;
        message.userBusinessName = "";
        message.userEmail = "";
        message.payable = 0;
        message.payed = 0;
        message.paymentTerms = 0;
        message.eligibleRate = 0;
        message.possibleAward = 0;
        message.rebateAmount = 0;
        message.rebateDate = "";
        message.orderBy = "";
        message.orderDir = "";
        message.dateTarget = [];
        message.dateRange = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* string billingDate */ 2:
                    message.billingDate = reader.string();
                    break;
                case /* string due_date */ 3:
                    message.dueDate = reader.string();
                    break;
                case /* string payment_date */ 4:
                    message.paymentDate = reader.string();
                    break;
                case /* string report_until */ 5:
                    message.reportUntil = reader.string();
                    break;
                case /* int32 days_to_pay */ 6:
                    message.daysToPay = reader.int32();
                    break;
                case /* string job_number */ 7:
                    message.jobNumber = reader.string();
                    break;
                case /* int32 user_id */ 8:
                    message.userId = reader.int32();
                    break;
                case /* string user_business_name */ 9:
                    message.userBusinessName = reader.string();
                    break;
                case /* string user_email */ 10:
                    message.userEmail = reader.string();
                    break;
                case /* double payable */ 11:
                    message.payable = reader.double();
                    break;
                case /* double payed */ 12:
                    message.payed = reader.double();
                    break;
                case /* int32 payment_terms */ 13:
                    message.paymentTerms = reader.int32();
                    break;
                case /* double eligible_rate */ 14:
                    message.eligibleRate = reader.double();
                    break;
                case /* double possible_award */ 15:
                    message.possibleAward = reader.double();
                    break;
                case /* double rebate_amount */ 16:
                    message.rebateAmount = reader.double();
                    break;
                case /* string rebate_date */ 17:
                    message.rebateDate = reader.string();
                    break;
                case /* string order_by */ 18:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 19:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string date_target */ 20:
                    message.dateTarget.push(reader.string());
                    break;
                case /* repeated string date_range */ 21:
                    message.dateRange.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* string billingDate = 2; */
        if (message.billingDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.billingDate);
        /* string due_date = 3; */
        if (message.dueDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.dueDate);
        /* string payment_date = 4; */
        if (message.paymentDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.paymentDate);
        /* string report_until = 5; */
        if (message.reportUntil !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.reportUntil);
        /* int32 days_to_pay = 6; */
        if (message.daysToPay !== 0)
            writer.tag(6, WireType.Varint).int32(message.daysToPay);
        /* string job_number = 7; */
        if (message.jobNumber !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.jobNumber);
        /* int32 user_id = 8; */
        if (message.userId !== 0)
            writer.tag(8, WireType.Varint).int32(message.userId);
        /* string user_business_name = 9; */
        if (message.userBusinessName !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.userBusinessName);
        /* string user_email = 10; */
        if (message.userEmail !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.userEmail);
        /* double payable = 11; */
        if (message.payable !== 0)
            writer.tag(11, WireType.Bit64).double(message.payable);
        /* double payed = 12; */
        if (message.payed !== 0)
            writer.tag(12, WireType.Bit64).double(message.payed);
        /* int32 payment_terms = 13; */
        if (message.paymentTerms !== 0)
            writer.tag(13, WireType.Varint).int32(message.paymentTerms);
        /* double eligible_rate = 14; */
        if (message.eligibleRate !== 0)
            writer.tag(14, WireType.Bit64).double(message.eligibleRate);
        /* double possible_award = 15; */
        if (message.possibleAward !== 0)
            writer.tag(15, WireType.Bit64).double(message.possibleAward);
        /* double rebate_amount = 16; */
        if (message.rebateAmount !== 0)
            writer.tag(16, WireType.Bit64).double(message.rebateAmount);
        /* string rebate_date = 17; */
        if (message.rebateDate !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.rebateDate);
        /* string order_by = 18; */
        if (message.orderBy !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 19; */
        if (message.orderDir !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string date_target = 20; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(20, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* repeated string date_range = 21; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(21, WireType.LengthDelimited).string(message.dateRange[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PromptPaymentReportLine
 */
export const PromptPaymentReportLine = new PromptPaymentReportLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransactionReportLine$Type extends MessageType {
    constructor() {
        super("TransactionReportLine", [
            { no: 1, name: "transaction_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "artificial_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "zoning", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "job_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "sub_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "class_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "department", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "category", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "vendor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "holder_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "transaction_timestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "posted_timestamp", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "amount", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "notes", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "year", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 19, name: "dry_run", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.transactionId = 0;
        message.artificialId = "";
        message.jobNumber = "";
        message.zoning = "";
        message.jobType = "";
        message.subType = "";
        message.classCode = "";
        message.department = "";
        message.category = "";
        message.vendor = "";
        message.holderName = "";
        message.transactionTimestamp = "";
        message.postedTimestamp = "";
        message.amount = "";
        message.notes = "";
        message.year = "";
        message.pageNumber = 0;
        message.withoutLimit = false;
        message.dryRun = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 transaction_id */ 1:
                    message.transactionId = reader.int32();
                    break;
                case /* string artificial_id */ 2:
                    message.artificialId = reader.string();
                    break;
                case /* string job_number */ 3:
                    message.jobNumber = reader.string();
                    break;
                case /* string zoning */ 4:
                    message.zoning = reader.string();
                    break;
                case /* string job_type */ 5:
                    message.jobType = reader.string();
                    break;
                case /* string sub_type */ 6:
                    message.subType = reader.string();
                    break;
                case /* string class_code */ 7:
                    message.classCode = reader.string();
                    break;
                case /* string department */ 8:
                    message.department = reader.string();
                    break;
                case /* string category */ 9:
                    message.category = reader.string();
                    break;
                case /* string vendor */ 10:
                    message.vendor = reader.string();
                    break;
                case /* string holder_name */ 11:
                    message.holderName = reader.string();
                    break;
                case /* string transaction_timestamp */ 12:
                    message.transactionTimestamp = reader.string();
                    break;
                case /* string posted_timestamp */ 13:
                    message.postedTimestamp = reader.string();
                    break;
                case /* string amount */ 14:
                    message.amount = reader.string();
                    break;
                case /* string notes */ 15:
                    message.notes = reader.string();
                    break;
                case /* string year */ 16:
                    message.year = reader.string();
                    break;
                case /* int32 page_number */ 17:
                    message.pageNumber = reader.int32();
                    break;
                case /* bool without_limit */ 18:
                    message.withoutLimit = reader.bool();
                    break;
                case /* bool dry_run */ 19:
                    message.dryRun = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 transaction_id = 1; */
        if (message.transactionId !== 0)
            writer.tag(1, WireType.Varint).int32(message.transactionId);
        /* string artificial_id = 2; */
        if (message.artificialId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.artificialId);
        /* string job_number = 3; */
        if (message.jobNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.jobNumber);
        /* string zoning = 4; */
        if (message.zoning !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.zoning);
        /* string job_type = 5; */
        if (message.jobType !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.jobType);
        /* string sub_type = 6; */
        if (message.subType !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.subType);
        /* string class_code = 7; */
        if (message.classCode !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.classCode);
        /* string department = 8; */
        if (message.department !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.department);
        /* string category = 9; */
        if (message.category !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.category);
        /* string vendor = 10; */
        if (message.vendor !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.vendor);
        /* string holder_name = 11; */
        if (message.holderName !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.holderName);
        /* string transaction_timestamp = 12; */
        if (message.transactionTimestamp !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.transactionTimestamp);
        /* string posted_timestamp = 13; */
        if (message.postedTimestamp !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.postedTimestamp);
        /* string amount = 14; */
        if (message.amount !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.amount);
        /* string notes = 15; */
        if (message.notes !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.notes);
        /* string year = 16; */
        if (message.year !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.year);
        /* int32 page_number = 17; */
        if (message.pageNumber !== 0)
            writer.tag(17, WireType.Varint).int32(message.pageNumber);
        /* bool without_limit = 18; */
        if (message.withoutLimit !== false)
            writer.tag(18, WireType.Varint).bool(message.withoutLimit);
        /* bool dry_run = 19; */
        if (message.dryRun !== false)
            writer.tag(19, WireType.Varint).bool(message.dryRun);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TransactionReportLine
 */
export const TransactionReportLine = new TransactionReportLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeoffReportRequest$Type extends MessageType {
    constructor() {
        super("TimeoffReportRequest", [
            { no: 1, name: "year_shift", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.yearShift = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 year_shift */ 1:
                    message.yearShift = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 year_shift = 1; */
        if (message.yearShift !== 0)
            writer.tag(1, WireType.Varint).int32(message.yearShift);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TimeoffReportRequest
 */
export const TimeoffReportRequest = new TimeoffReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeoffReportLine$Type extends MessageType {
    constructor() {
        super("TimeoffReportLine", [
            { no: 1, name: "employee_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_firstname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_lastname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "hire_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "annual_hours_pto", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "hire_date_discretionary", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "hire_date_mandatory", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "hire_date_pto", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "hire_date_paid_downtime", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "annual_discretionary", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "annual_mandatory", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "annual_pto", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "annual_paid_downtime", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.employeeId = 0;
        message.userFirstname = "";
        message.userLastname = "";
        message.hireDate = "";
        message.annualHoursPto = "";
        message.hireDateDiscretionary = "";
        message.hireDateMandatory = "";
        message.hireDatePto = "";
        message.hireDatePaidDowntime = "";
        message.annualDiscretionary = "";
        message.annualMandatory = "";
        message.annualPto = "";
        message.annualPaidDowntime = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 employee_id */ 1:
                    message.employeeId = reader.int32();
                    break;
                case /* string user_firstname */ 2:
                    message.userFirstname = reader.string();
                    break;
                case /* string user_lastname */ 3:
                    message.userLastname = reader.string();
                    break;
                case /* string hire_date */ 4:
                    message.hireDate = reader.string();
                    break;
                case /* string annual_hours_pto */ 5:
                    message.annualHoursPto = reader.string();
                    break;
                case /* string hire_date_discretionary */ 6:
                    message.hireDateDiscretionary = reader.string();
                    break;
                case /* string hire_date_mandatory */ 7:
                    message.hireDateMandatory = reader.string();
                    break;
                case /* string hire_date_pto */ 8:
                    message.hireDatePto = reader.string();
                    break;
                case /* string hire_date_paid_downtime */ 9:
                    message.hireDatePaidDowntime = reader.string();
                    break;
                case /* string annual_discretionary */ 10:
                    message.annualDiscretionary = reader.string();
                    break;
                case /* string annual_mandatory */ 11:
                    message.annualMandatory = reader.string();
                    break;
                case /* string annual_pto */ 12:
                    message.annualPto = reader.string();
                    break;
                case /* string annual_paid_downtime */ 13:
                    message.annualPaidDowntime = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 employee_id = 1; */
        if (message.employeeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.employeeId);
        /* string user_firstname = 2; */
        if (message.userFirstname !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userFirstname);
        /* string user_lastname = 3; */
        if (message.userLastname !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userLastname);
        /* string hire_date = 4; */
        if (message.hireDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.hireDate);
        /* string annual_hours_pto = 5; */
        if (message.annualHoursPto !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.annualHoursPto);
        /* string hire_date_discretionary = 6; */
        if (message.hireDateDiscretionary !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.hireDateDiscretionary);
        /* string hire_date_mandatory = 7; */
        if (message.hireDateMandatory !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.hireDateMandatory);
        /* string hire_date_pto = 8; */
        if (message.hireDatePto !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.hireDatePto);
        /* string hire_date_paid_downtime = 9; */
        if (message.hireDatePaidDowntime !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.hireDatePaidDowntime);
        /* string annual_discretionary = 10; */
        if (message.annualDiscretionary !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.annualDiscretionary);
        /* string annual_mandatory = 11; */
        if (message.annualMandatory !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.annualMandatory);
        /* string annual_pto = 12; */
        if (message.annualPto !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.annualPto);
        /* string annual_paid_downtime = 13; */
        if (message.annualPaidDowntime !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.annualPaidDowntime);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TimeoffReportLine
 */
export const TimeoffReportLine = new TimeoffReportLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProcessedReportLine$Type extends MessageType {
    constructor() {
        super("ProcessedReportLine", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "user_firstname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_lastname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "total_lodging", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "total_meals", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "total_mileage", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "total_spiffs", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "total_processed_hours", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "total_mileage_cost", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "department_description", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "employee_department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.userFirstname = "";
        message.userLastname = "";
        message.totalLodging = "";
        message.totalMeals = "";
        message.totalMileage = "";
        message.totalSpiffs = "";
        message.totalProcessedHours = "";
        message.totalMileageCost = "";
        message.departmentDescription = "";
        message.employeeDepartmentId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* string user_firstname */ 2:
                    message.userFirstname = reader.string();
                    break;
                case /* string user_lastname */ 3:
                    message.userLastname = reader.string();
                    break;
                case /* string total_lodging */ 4:
                    message.totalLodging = reader.string();
                    break;
                case /* string total_meals */ 5:
                    message.totalMeals = reader.string();
                    break;
                case /* string total_mileage */ 6:
                    message.totalMileage = reader.string();
                    break;
                case /* string total_spiffs */ 7:
                    message.totalSpiffs = reader.string();
                    break;
                case /* string total_processed_hours */ 8:
                    message.totalProcessedHours = reader.string();
                    break;
                case /* string total_mileage_cost */ 9:
                    message.totalMileageCost = reader.string();
                    break;
                case /* string department_description */ 10:
                    message.departmentDescription = reader.string();
                    break;
                case /* int32 employee_department_id */ 11:
                    message.employeeDepartmentId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* string user_firstname = 2; */
        if (message.userFirstname !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userFirstname);
        /* string user_lastname = 3; */
        if (message.userLastname !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userLastname);
        /* string total_lodging = 4; */
        if (message.totalLodging !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.totalLodging);
        /* string total_meals = 5; */
        if (message.totalMeals !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.totalMeals);
        /* string total_mileage = 6; */
        if (message.totalMileage !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.totalMileage);
        /* string total_spiffs = 7; */
        if (message.totalSpiffs !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.totalSpiffs);
        /* string total_processed_hours = 8; */
        if (message.totalProcessedHours !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.totalProcessedHours);
        /* string total_mileage_cost = 9; */
        if (message.totalMileageCost !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.totalMileageCost);
        /* string department_description = 10; */
        if (message.departmentDescription !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.departmentDescription);
        /* int32 employee_department_id = 11; */
        if (message.employeeDepartmentId !== 0)
            writer.tag(11, WireType.Varint).int32(message.employeeDepartmentId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProcessedReportLine
 */
export const ProcessedReportLine = new ProcessedReportLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReceiptJournalReportLine$Type extends MessageType {
    constructor() {
        super("ReceiptJournalReportLine", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "payment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "amount_collected", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "sr_datetime", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 7, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "date_target", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.paymentType = "";
        message.amountCollected = 0;
        message.srDatetime = "";
        message.departmentId = 0;
        message.withoutLimit = false;
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.dateRange = [];
        message.dateTarget = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* string payment_type */ 2:
                    message.paymentType = reader.string();
                    break;
                case /* double amount_collected */ 3:
                    message.amountCollected = reader.double();
                    break;
                case /* string sr_datetime */ 4:
                    message.srDatetime = reader.string();
                    break;
                case /* int32 department_id */ 5:
                    message.departmentId = reader.int32();
                    break;
                case /* bool without_limit */ 6:
                    message.withoutLimit = reader.bool();
                    break;
                case /* int32 page_number */ 7:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 8:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 9:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string date_range */ 10:
                    message.dateRange.push(reader.string());
                    break;
                case /* string date_target */ 11:
                    message.dateTarget = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* string payment_type = 2; */
        if (message.paymentType !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.paymentType);
        /* double amount_collected = 3; */
        if (message.amountCollected !== 0)
            writer.tag(3, WireType.Bit64).double(message.amountCollected);
        /* string sr_datetime = 4; */
        if (message.srDatetime !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.srDatetime);
        /* int32 department_id = 5; */
        if (message.departmentId !== 0)
            writer.tag(5, WireType.Varint).int32(message.departmentId);
        /* bool without_limit = 6; */
        if (message.withoutLimit !== false)
            writer.tag(6, WireType.Varint).bool(message.withoutLimit);
        /* int32 page_number = 7; */
        if (message.pageNumber !== 0)
            writer.tag(7, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 8; */
        if (message.orderBy !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 9; */
        if (message.orderDir !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string date_range = 10; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(10, WireType.LengthDelimited).string(message.dateRange[i]);
        /* string date_target = 11; */
        if (message.dateTarget !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.dateTarget);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReceiptJournalReportLine
 */
export const ReceiptJournalReportLine = new ReceiptJournalReportLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SalesJournalReportLine$Type extends MessageType {
    constructor() {
        super("SalesJournalReportLine", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "service_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "billing_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 9, name: "total_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 11, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.serviceDate = "";
        message.customerId = 0;
        message.customerName = "";
        message.status = "";
        message.jobTypeId = 0;
        message.billingDate = "";
        message.departmentId = 0;
        message.totalAmount = 0;
        message.withoutLimit = false;
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.dateRange = [];
        message.dateTarget = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* string service_date */ 2:
                    message.serviceDate = reader.string();
                    break;
                case /* int32 customer_id */ 3:
                    message.customerId = reader.int32();
                    break;
                case /* string customer_name */ 4:
                    message.customerName = reader.string();
                    break;
                case /* string status */ 5:
                    message.status = reader.string();
                    break;
                case /* int32 job_type_id */ 6:
                    message.jobTypeId = reader.int32();
                    break;
                case /* string billing_date */ 7:
                    message.billingDate = reader.string();
                    break;
                case /* int32 department_id */ 8:
                    message.departmentId = reader.int32();
                    break;
                case /* double total_amount */ 9:
                    message.totalAmount = reader.double();
                    break;
                case /* bool without_limit */ 10:
                    message.withoutLimit = reader.bool();
                    break;
                case /* int32 page_number */ 11:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 12:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 13:
                    message.orderDir = reader.string();
                    break;
                case /* repeated string date_range */ 14:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 15:
                    message.dateTarget.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* string service_date = 2; */
        if (message.serviceDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.serviceDate);
        /* int32 customer_id = 3; */
        if (message.customerId !== 0)
            writer.tag(3, WireType.Varint).int32(message.customerId);
        /* string customer_name = 4; */
        if (message.customerName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.customerName);
        /* string status = 5; */
        if (message.status !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.status);
        /* int32 job_type_id = 6; */
        if (message.jobTypeId !== 0)
            writer.tag(6, WireType.Varint).int32(message.jobTypeId);
        /* string billing_date = 7; */
        if (message.billingDate !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.billingDate);
        /* int32 department_id = 8; */
        if (message.departmentId !== 0)
            writer.tag(8, WireType.Varint).int32(message.departmentId);
        /* double total_amount = 9; */
        if (message.totalAmount !== 0)
            writer.tag(9, WireType.Bit64).double(message.totalAmount);
        /* bool without_limit = 10; */
        if (message.withoutLimit !== false)
            writer.tag(10, WireType.Varint).bool(message.withoutLimit);
        /* int32 page_number = 11; */
        if (message.pageNumber !== 0)
            writer.tag(11, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 12; */
        if (message.orderBy !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 13; */
        if (message.orderDir !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.orderDir);
        /* repeated string date_range = 14; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(14, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 15; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.dateTarget[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SalesJournalReportLine
 */
export const SalesJournalReportLine = new SalesJournalReportLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CostItem$Type extends MessageType {
    constructor() {
        super("CostItem", [
            { no: 1, name: "employee_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "employee_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "main_cost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "sub_cost", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "entity_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "entity_joined_table_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.employeeId = 0;
        message.employeeName = "";
        message.departmentId = 0;
        message.date = "";
        message.jobNumber = "";
        message.mainCost = 0;
        message.subCost = 0;
        message.type = "";
        message.entityId = 0;
        message.entityJoinedTableId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 employee_id */ 1:
                    message.employeeId = reader.int32();
                    break;
                case /* string employee_name */ 2:
                    message.employeeName = reader.string();
                    break;
                case /* int32 department_id */ 3:
                    message.departmentId = reader.int32();
                    break;
                case /* string date */ 4:
                    message.date = reader.string();
                    break;
                case /* string job_number */ 5:
                    message.jobNumber = reader.string();
                    break;
                case /* float main_cost */ 6:
                    message.mainCost = reader.float();
                    break;
                case /* float sub_cost */ 7:
                    message.subCost = reader.float();
                    break;
                case /* string type */ 8:
                    message.type = reader.string();
                    break;
                case /* int32 entity_id */ 9:
                    message.entityId = reader.int32();
                    break;
                case /* int32 entity_joined_table_id */ 10:
                    message.entityJoinedTableId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 employee_id = 1; */
        if (message.employeeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.employeeId);
        /* string employee_name = 2; */
        if (message.employeeName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.employeeName);
        /* int32 department_id = 3; */
        if (message.departmentId !== 0)
            writer.tag(3, WireType.Varint).int32(message.departmentId);
        /* string date = 4; */
        if (message.date !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.date);
        /* string job_number = 5; */
        if (message.jobNumber !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.jobNumber);
        /* float main_cost = 6; */
        if (message.mainCost !== 0)
            writer.tag(6, WireType.Bit32).float(message.mainCost);
        /* float sub_cost = 7; */
        if (message.subCost !== 0)
            writer.tag(7, WireType.Bit32).float(message.subCost);
        /* string type = 8; */
        if (message.type !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.type);
        /* int32 entity_id = 9; */
        if (message.entityId !== 0)
            writer.tag(9, WireType.Varint).int32(message.entityId);
        /* int32 entity_joined_table_id = 10; */
        if (message.entityJoinedTableId !== 0)
            writer.tag(10, WireType.Varint).int32(message.entityJoinedTableId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CostItem
 */
export const CostItem = new CostItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BillingAudit$Type extends MessageType {
    constructor() {
        super("BillingAudit", [
            { no: 1, name: "log_billingDate", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "userName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "businessName", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "log_jobNumber", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "log_paymentStatus", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "payable", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "payed", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 13, name: "income", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 14, name: "site_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "is_tracked", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "log_po", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "job_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 19, name: "job_subtype_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 20, name: "log_paymentType", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.logBillingDate = "";
        message.userId = 0;
        message.invoiceId = 0;
        message.eventId = 0;
        message.propertyId = 0;
        message.documentId = 0;
        message.userName = "";
        message.businessName = "";
        message.logJobNumber = "";
        message.logPaymentStatus = "";
        message.payable = 0;
        message.payed = 0;
        message.income = 0;
        message.siteAddress = "";
        message.isTracked = false;
        message.logPo = "";
        message.departmentName = "";
        message.jobTypeId = 0;
        message.jobSubtypeId = 0;
        message.logPaymentType = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string log_billingDate */ 1:
                    message.logBillingDate = reader.string();
                    break;
                case /* int32 user_id */ 2:
                    message.userId = reader.int32();
                    break;
                case /* int32 invoice_id */ 3:
                    message.invoiceId = reader.int32();
                    break;
                case /* int32 event_id */ 4:
                    message.eventId = reader.int32();
                    break;
                case /* int32 property_id */ 5:
                    message.propertyId = reader.int32();
                    break;
                case /* int32 document_id */ 6:
                    message.documentId = reader.int32();
                    break;
                case /* string userName */ 7:
                    message.userName = reader.string();
                    break;
                case /* string businessName */ 8:
                    message.businessName = reader.string();
                    break;
                case /* string log_jobNumber */ 9:
                    message.logJobNumber = reader.string();
                    break;
                case /* string log_paymentStatus */ 10:
                    message.logPaymentStatus = reader.string();
                    break;
                case /* float payable */ 11:
                    message.payable = reader.float();
                    break;
                case /* float payed */ 12:
                    message.payed = reader.float();
                    break;
                case /* float income */ 13:
                    message.income = reader.float();
                    break;
                case /* string site_address */ 14:
                    message.siteAddress = reader.string();
                    break;
                case /* bool is_tracked */ 15:
                    message.isTracked = reader.bool();
                    break;
                case /* string log_po */ 16:
                    message.logPo = reader.string();
                    break;
                case /* string department_name */ 17:
                    message.departmentName = reader.string();
                    break;
                case /* int32 job_type_id */ 18:
                    message.jobTypeId = reader.int32();
                    break;
                case /* int32 job_subtype_id */ 19:
                    message.jobSubtypeId = reader.int32();
                    break;
                case /* string log_paymentType */ 20:
                    message.logPaymentType = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string log_billingDate = 1; */
        if (message.logBillingDate !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.logBillingDate);
        /* int32 user_id = 2; */
        if (message.userId !== 0)
            writer.tag(2, WireType.Varint).int32(message.userId);
        /* int32 invoice_id = 3; */
        if (message.invoiceId !== 0)
            writer.tag(3, WireType.Varint).int32(message.invoiceId);
        /* int32 event_id = 4; */
        if (message.eventId !== 0)
            writer.tag(4, WireType.Varint).int32(message.eventId);
        /* int32 property_id = 5; */
        if (message.propertyId !== 0)
            writer.tag(5, WireType.Varint).int32(message.propertyId);
        /* int32 document_id = 6; */
        if (message.documentId !== 0)
            writer.tag(6, WireType.Varint).int32(message.documentId);
        /* string userName = 7; */
        if (message.userName !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.userName);
        /* string businessName = 8; */
        if (message.businessName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.businessName);
        /* string log_jobNumber = 9; */
        if (message.logJobNumber !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.logJobNumber);
        /* string log_paymentStatus = 10; */
        if (message.logPaymentStatus !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.logPaymentStatus);
        /* float payable = 11; */
        if (message.payable !== 0)
            writer.tag(11, WireType.Bit32).float(message.payable);
        /* float payed = 12; */
        if (message.payed !== 0)
            writer.tag(12, WireType.Bit32).float(message.payed);
        /* float income = 13; */
        if (message.income !== 0)
            writer.tag(13, WireType.Bit32).float(message.income);
        /* string site_address = 14; */
        if (message.siteAddress !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.siteAddress);
        /* bool is_tracked = 15; */
        if (message.isTracked !== false)
            writer.tag(15, WireType.Varint).bool(message.isTracked);
        /* string log_po = 16; */
        if (message.logPo !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.logPo);
        /* string department_name = 17; */
        if (message.departmentName !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.departmentName);
        /* int32 job_type_id = 18; */
        if (message.jobTypeId !== 0)
            writer.tag(18, WireType.Varint).int32(message.jobTypeId);
        /* int32 job_subtype_id = 19; */
        if (message.jobSubtypeId !== 0)
            writer.tag(19, WireType.Varint).int32(message.jobSubtypeId);
        /* string log_paymentType = 20; */
        if (message.logPaymentType !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.logPaymentType);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BillingAudit
 */
export const BillingAudit = new BillingAudit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobHoursEmployee$Type extends MessageType {
    constructor() {
        super("JobHoursEmployee", [
            { no: 1, name: "job_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "employee_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "employee_first_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "employee_last_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "hours", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobNumber = 0;
        message.employeeId = 0;
        message.employeeFirstName = "";
        message.employeeLastName = "";
        message.hours = 0;
        message.date = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 job_number */ 1:
                    message.jobNumber = reader.int32();
                    break;
                case /* int32 employee_id */ 2:
                    message.employeeId = reader.int32();
                    break;
                case /* string employee_first_name */ 3:
                    message.employeeFirstName = reader.string();
                    break;
                case /* string employee_last_name */ 4:
                    message.employeeLastName = reader.string();
                    break;
                case /* float hours */ 5:
                    message.hours = reader.float();
                    break;
                case /* string date */ 6:
                    message.date = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 job_number = 1; */
        if (message.jobNumber !== 0)
            writer.tag(1, WireType.Varint).int32(message.jobNumber);
        /* int32 employee_id = 2; */
        if (message.employeeId !== 0)
            writer.tag(2, WireType.Varint).int32(message.employeeId);
        /* string employee_first_name = 3; */
        if (message.employeeFirstName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.employeeFirstName);
        /* string employee_last_name = 4; */
        if (message.employeeLastName !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.employeeLastName);
        /* float hours = 5; */
        if (message.hours !== 0)
            writer.tag(5, WireType.Bit32).float(message.hours);
        /* string date = 6; */
        if (message.date !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.date);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message JobHoursEmployee
 */
export const JobHoursEmployee = new JobHoursEmployee$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceJournalEntry$Type extends MessageType {
    constructor() {
        super("InvoiceJournalEntry", [
            { no: 1, name: "transaction_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "invoice_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "order_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "job_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 6, name: "cost_center_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 7, name: "amount", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "vendor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "invoice_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "job_start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "invoice_upload_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "accepted_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "processed_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "rejected_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.transactionId = 0;
        message.invoiceNumber = "";
        message.orderNumber = "";
        message.jobNumber = 0;
        message.departmentId = 0;
        message.costCenterId = 0;
        message.amount = "";
        message.vendor = "";
        message.invoiceDate = "";
        message.jobStartDate = "";
        message.invoiceUploadDate = "";
        message.acceptedDate = "";
        message.processedDate = "";
        message.rejectedDate = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 transaction_id */ 1:
                    message.transactionId = reader.int32();
                    break;
                case /* string invoice_number */ 2:
                    message.invoiceNumber = reader.string();
                    break;
                case /* string order_number */ 3:
                    message.orderNumber = reader.string();
                    break;
                case /* int32 job_number */ 4:
                    message.jobNumber = reader.int32();
                    break;
                case /* int32 department_id */ 5:
                    message.departmentId = reader.int32();
                    break;
                case /* int32 cost_center_id */ 6:
                    message.costCenterId = reader.int32();
                    break;
                case /* string amount */ 7:
                    message.amount = reader.string();
                    break;
                case /* string vendor */ 8:
                    message.vendor = reader.string();
                    break;
                case /* string invoice_date */ 9:
                    message.invoiceDate = reader.string();
                    break;
                case /* string job_start_date */ 10:
                    message.jobStartDate = reader.string();
                    break;
                case /* string invoice_upload_date */ 11:
                    message.invoiceUploadDate = reader.string();
                    break;
                case /* string accepted_date */ 12:
                    message.acceptedDate = reader.string();
                    break;
                case /* string processed_date */ 13:
                    message.processedDate = reader.string();
                    break;
                case /* string rejected_date */ 14:
                    message.rejectedDate = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 transaction_id = 1; */
        if (message.transactionId !== 0)
            writer.tag(1, WireType.Varint).int32(message.transactionId);
        /* string invoice_number = 2; */
        if (message.invoiceNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.invoiceNumber);
        /* string order_number = 3; */
        if (message.orderNumber !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.orderNumber);
        /* int32 job_number = 4; */
        if (message.jobNumber !== 0)
            writer.tag(4, WireType.Varint).int32(message.jobNumber);
        /* int32 department_id = 5; */
        if (message.departmentId !== 0)
            writer.tag(5, WireType.Varint).int32(message.departmentId);
        /* int32 cost_center_id = 6; */
        if (message.costCenterId !== 0)
            writer.tag(6, WireType.Varint).int32(message.costCenterId);
        /* string amount = 7; */
        if (message.amount !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.amount);
        /* string vendor = 8; */
        if (message.vendor !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.vendor);
        /* string invoice_date = 9; */
        if (message.invoiceDate !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.invoiceDate);
        /* string job_start_date = 10; */
        if (message.jobStartDate !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.jobStartDate);
        /* string invoice_upload_date = 11; */
        if (message.invoiceUploadDate !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.invoiceUploadDate);
        /* string accepted_date = 12; */
        if (message.acceptedDate !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.acceptedDate);
        /* string processed_date = 13; */
        if (message.processedDate !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.processedDate);
        /* string rejected_date = 14; */
        if (message.rejectedDate !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.rejectedDate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoiceJournalEntry
 */
export const InvoiceJournalEntry = new InvoiceJournalEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DailyJobEntry$Type extends MessageType {
    constructor() {
        super("DailyJobEntry", [
            { no: 1, name: "start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "business_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "job_address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "zip_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "division", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "phone_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "job_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "job_sub_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "job_contract", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "job_link", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "is_tracked", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 15, name: "tracked_job_type", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 16, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.startDate = "";
        message.customerName = "";
        message.businessName = "";
        message.jobAddress = "";
        message.city = "";
        message.zipCode = "";
        message.division = "";
        message.phoneNumber = "";
        message.jobNumber = "";
        message.jobType = "";
        message.jobSubType = "";
        message.jobContract = "";
        message.jobLink = "";
        message.isTracked = false;
        message.trackedJobType = false;
        message.eventId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string start_date */ 1:
                    message.startDate = reader.string();
                    break;
                case /* string customer_name */ 2:
                    message.customerName = reader.string();
                    break;
                case /* string business_name */ 3:
                    message.businessName = reader.string();
                    break;
                case /* string job_address */ 4:
                    message.jobAddress = reader.string();
                    break;
                case /* string city */ 5:
                    message.city = reader.string();
                    break;
                case /* string zip_code */ 6:
                    message.zipCode = reader.string();
                    break;
                case /* string division */ 7:
                    message.division = reader.string();
                    break;
                case /* string phone_number */ 8:
                    message.phoneNumber = reader.string();
                    break;
                case /* string job_number */ 9:
                    message.jobNumber = reader.string();
                    break;
                case /* string job_type */ 10:
                    message.jobType = reader.string();
                    break;
                case /* string job_sub_type */ 11:
                    message.jobSubType = reader.string();
                    break;
                case /* string job_contract */ 12:
                    message.jobContract = reader.string();
                    break;
                case /* string job_link */ 13:
                    message.jobLink = reader.string();
                    break;
                case /* bool is_tracked */ 14:
                    message.isTracked = reader.bool();
                    break;
                case /* bool tracked_job_type */ 15:
                    message.trackedJobType = reader.bool();
                    break;
                case /* int32 event_id */ 16:
                    message.eventId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string start_date = 1; */
        if (message.startDate !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.startDate);
        /* string customer_name = 2; */
        if (message.customerName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerName);
        /* string business_name = 3; */
        if (message.businessName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.businessName);
        /* string job_address = 4; */
        if (message.jobAddress !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.jobAddress);
        /* string city = 5; */
        if (message.city !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.city);
        /* string zip_code = 6; */
        if (message.zipCode !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.zipCode);
        /* string division = 7; */
        if (message.division !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.division);
        /* string phone_number = 8; */
        if (message.phoneNumber !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.phoneNumber);
        /* string job_number = 9; */
        if (message.jobNumber !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.jobNumber);
        /* string job_type = 10; */
        if (message.jobType !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.jobType);
        /* string job_sub_type = 11; */
        if (message.jobSubType !== "")
            writer.tag(11, WireType.LengthDelimited).string(message.jobSubType);
        /* string job_contract = 12; */
        if (message.jobContract !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.jobContract);
        /* string job_link = 13; */
        if (message.jobLink !== "")
            writer.tag(13, WireType.LengthDelimited).string(message.jobLink);
        /* bool is_tracked = 14; */
        if (message.isTracked !== false)
            writer.tag(14, WireType.Varint).bool(message.isTracked);
        /* bool tracked_job_type = 15; */
        if (message.trackedJobType !== false)
            writer.tag(15, WireType.Varint).bool(message.trackedJobType);
        /* int32 event_id = 16; */
        if (message.eventId !== 0)
            writer.tag(16, WireType.Varint).int32(message.eventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DailyJobEntry
 */
export const DailyJobEntry = new DailyJobEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DailyJobReport$Type extends MessageType {
    constructor() {
        super("DailyJobReport", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => DailyJobEntry },
            { no: 2, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated DailyJobEntry data */ 1:
                    message.data.push(DailyJobEntry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 count */ 2:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated DailyJobEntry data = 1; */
        for (let i = 0; i < message.data.length; i++)
            DailyJobEntry.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message DailyJobReport
 */
export const DailyJobReport = new DailyJobReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InvoiceJournalReport$Type extends MessageType {
    constructor() {
        super("InvoiceJournalReport", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InvoiceJournalEntry },
            { no: 2, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated InvoiceJournalEntry data */ 1:
                    message.data.push(InvoiceJournalEntry.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 count */ 2:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated InvoiceJournalEntry data = 1; */
        for (let i = 0; i < message.data.length; i++)
            InvoiceJournalEntry.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message InvoiceJournalReport
 */
export const InvoiceJournalReport = new InvoiceJournalReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobHoursEmployeeReport$Type extends MessageType {
    constructor() {
        super("JobHoursEmployeeReport", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JobHoursEmployee },
            { no: 2, name: "count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        message.count = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated JobHoursEmployee data */ 1:
                    message.data.push(JobHoursEmployee.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 count */ 2:
                    message.count = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated JobHoursEmployee data = 1; */
        for (let i = 0; i < message.data.length; i++)
            JobHoursEmployee.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 count = 2; */
        if (message.count !== 0)
            writer.tag(2, WireType.Varint).int32(message.count);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message JobHoursEmployeeReport
 */
export const JobHoursEmployeeReport = new JobHoursEmployeeReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CostItemReport$Type extends MessageType {
    constructor() {
        super("CostItemReport", [
            { no: 1, name: "trip_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CostItem },
            { no: 2, name: "per_diem_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CostItem },
            { no: 3, name: "spiff_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CostItem },
            { no: 4, name: "reimbursement_data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CostItem }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.tripData = [];
        message.perDiemData = [];
        message.spiffData = [];
        message.reimbursementData = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CostItem trip_data */ 1:
                    message.tripData.push(CostItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated CostItem per_diem_data */ 2:
                    message.perDiemData.push(CostItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated CostItem spiff_data */ 3:
                    message.spiffData.push(CostItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* repeated CostItem reimbursement_data */ 4:
                    message.reimbursementData.push(CostItem.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated CostItem trip_data = 1; */
        for (let i = 0; i < message.tripData.length; i++)
            CostItem.internalBinaryWrite(message.tripData[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* repeated CostItem per_diem_data = 2; */
        for (let i = 0; i < message.perDiemData.length; i++)
            CostItem.internalBinaryWrite(message.perDiemData[i], writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* repeated CostItem spiff_data = 3; */
        for (let i = 0; i < message.spiffData.length; i++)
            CostItem.internalBinaryWrite(message.spiffData[i], writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        /* repeated CostItem reimbursement_data = 4; */
        for (let i = 0; i < message.reimbursementData.length; i++)
            CostItem.internalBinaryWrite(message.reimbursementData[i], writer.tag(4, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CostItemReport
 */
export const CostItemReport = new CostItemReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromptPaymentReport$Type extends MessageType {
    constructor() {
        super("PromptPaymentReport", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PromptPaymentReportLine }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PromptPaymentReportLine data */ 1:
                    message.data.push(PromptPaymentReportLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PromptPaymentReportLine data = 1; */
        for (let i = 0; i < message.data.length; i++)
            PromptPaymentReportLine.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PromptPaymentReport
 */
export const PromptPaymentReport = new PromptPaymentReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReceiptJournalReport$Type extends MessageType {
    constructor() {
        super("ReceiptJournalReport", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ReceiptJournalReportLine },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ReceiptJournalReportLine data */ 1:
                    message.data.push(ReceiptJournalReportLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ReceiptJournalReportLine data = 1; */
        for (let i = 0; i < message.data.length; i++)
            ReceiptJournalReportLine.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReceiptJournalReport
 */
export const ReceiptJournalReport = new ReceiptJournalReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SalesJournalReport$Type extends MessageType {
    constructor() {
        super("SalesJournalReport", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SalesJournalReportLine },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SalesJournalReportLine data */ 1:
                    message.data.push(SalesJournalReportLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SalesJournalReportLine data = 1; */
        for (let i = 0; i < message.data.length; i++)
            SalesJournalReportLine.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SalesJournalReport
 */
export const SalesJournalReport = new SalesJournalReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TransactionDumpReport$Type extends MessageType {
    constructor() {
        super("TransactionDumpReport", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TransactionReportLine },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated TransactionReportLine data */ 1:
                    message.data.push(TransactionReportLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated TransactionReportLine data = 1; */
        for (let i = 0; i < message.data.length; i++)
            TransactionReportLine.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TransactionDumpReport
 */
export const TransactionDumpReport = new TransactionDumpReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBOSpreadsheetSyncExport$Type extends MessageType {
    constructor() {
        super("QBOSpreadsheetSyncExport", [
            { no: 1, name: "file_data", kind: "scalar", T: 12 /*ScalarType.BYTES*/ },
            { no: 2, name: "filename", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "unmapped_job_numbers", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "unmapped_categories", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "row_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.fileData = new Uint8Array(0);
        message.filename = "";
        message.unmappedJobNumbers = [];
        message.unmappedCategories = [];
        message.rowCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* bytes file_data */ 1:
                    message.fileData = reader.bytes();
                    break;
                case /* string filename */ 2:
                    message.filename = reader.string();
                    break;
                case /* repeated string unmapped_job_numbers */ 3:
                    message.unmappedJobNumbers.push(reader.string());
                    break;
                case /* repeated string unmapped_categories */ 4:
                    message.unmappedCategories.push(reader.string());
                    break;
                case /* int32 row_count */ 5:
                    message.rowCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* bytes file_data = 1; */
        if (message.fileData.length)
            writer.tag(1, WireType.LengthDelimited).bytes(message.fileData);
        /* string filename = 2; */
        if (message.filename !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.filename);
        /* repeated string unmapped_job_numbers = 3; */
        for (let i = 0; i < message.unmappedJobNumbers.length; i++)
            writer.tag(3, WireType.LengthDelimited).string(message.unmappedJobNumbers[i]);
        /* repeated string unmapped_categories = 4; */
        for (let i = 0; i < message.unmappedCategories.length; i++)
            writer.tag(4, WireType.LengthDelimited).string(message.unmappedCategories[i]);
        /* int32 row_count = 5; */
        if (message.rowCount !== 0)
            writer.tag(5, WireType.Varint).int32(message.rowCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBOSpreadsheetSyncExport
 */
export const QBOSpreadsheetSyncExport = new QBOSpreadsheetSyncExport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBOTransactionSyncReport$Type extends MessageType {
    constructor() {
        super("QBOTransactionSyncReport", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QBOTransactionSyncResult },
            { no: 2, name: "succeeded", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "skipped", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "failed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "unmapped_categories", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "unmapped_job_numbers", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.succeeded = 0;
        message.skipped = 0;
        message.failed = 0;
        message.unmappedCategories = [];
        message.unmappedJobNumbers = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QBOTransactionSyncResult results */ 1:
                    message.results.push(QBOTransactionSyncResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 succeeded */ 2:
                    message.succeeded = reader.int32();
                    break;
                case /* int32 skipped */ 3:
                    message.skipped = reader.int32();
                    break;
                case /* int32 failed */ 4:
                    message.failed = reader.int32();
                    break;
                case /* repeated string unmapped_categories */ 5:
                    message.unmappedCategories.push(reader.string());
                    break;
                case /* repeated string unmapped_job_numbers */ 6:
                    message.unmappedJobNumbers.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QBOTransactionSyncResult results = 1; */
        for (let i = 0; i < message.results.length; i++)
            QBOTransactionSyncResult.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 succeeded = 2; */
        if (message.succeeded !== 0)
            writer.tag(2, WireType.Varint).int32(message.succeeded);
        /* int32 skipped = 3; */
        if (message.skipped !== 0)
            writer.tag(3, WireType.Varint).int32(message.skipped);
        /* int32 failed = 4; */
        if (message.failed !== 0)
            writer.tag(4, WireType.Varint).int32(message.failed);
        /* repeated string unmapped_categories = 5; */
        for (let i = 0; i < message.unmappedCategories.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.unmappedCategories[i]);
        /* repeated string unmapped_job_numbers = 6; */
        for (let i = 0; i < message.unmappedJobNumbers.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.unmappedJobNumbers[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBOTransactionSyncReport
 */
export const QBOTransactionSyncReport = new QBOTransactionSyncReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBOTransactionSyncResult$Type extends MessageType {
    constructor() {
        super("QBOTransactionSyncResult", [
            { no: 1, name: "transaction_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "artificial_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "qb_purchase_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "error_message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "error_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "is_credit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.transactionId = 0;
        message.artificialId = "";
        message.status = "";
        message.qbPurchaseId = "";
        message.errorMessage = "";
        message.errorCode = "";
        message.isCredit = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 transaction_id */ 1:
                    message.transactionId = reader.int32();
                    break;
                case /* string artificial_id */ 2:
                    message.artificialId = reader.string();
                    break;
                case /* string status */ 3:
                    message.status = reader.string();
                    break;
                case /* string qb_purchase_id */ 4:
                    message.qbPurchaseId = reader.string();
                    break;
                case /* string error_message */ 5:
                    message.errorMessage = reader.string();
                    break;
                case /* string error_code */ 6:
                    message.errorCode = reader.string();
                    break;
                case /* bool is_credit */ 7:
                    message.isCredit = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 transaction_id = 1; */
        if (message.transactionId !== 0)
            writer.tag(1, WireType.Varint).int32(message.transactionId);
        /* string artificial_id = 2; */
        if (message.artificialId !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.artificialId);
        /* string status = 3; */
        if (message.status !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.status);
        /* string qb_purchase_id = 4; */
        if (message.qbPurchaseId !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.qbPurchaseId);
        /* string error_message = 5; */
        if (message.errorMessage !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.errorMessage);
        /* string error_code = 6; */
        if (message.errorCode !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.errorCode);
        /* bool is_credit = 7; */
        if (message.isCredit !== false)
            writer.tag(7, WireType.Varint).bool(message.isCredit);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBOTransactionSyncResult
 */
export const QBOTransactionSyncResult = new QBOTransactionSyncResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBOBillSyncRequest$Type extends MessageType {
    constructor() {
        super("QBOBillSyncRequest", [
            { no: 1, name: "transaction_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "dry_run", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 3, name: "admin_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.transactionIds = [];
        message.dryRun = false;
        message.adminId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int32 transaction_ids */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.transactionIds.push(reader.int32());
                    else
                        message.transactionIds.push(reader.int32());
                    break;
                case /* bool dry_run */ 2:
                    message.dryRun = reader.bool();
                    break;
                case /* int32 admin_id */ 3:
                    message.adminId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated int32 transaction_ids = 1; */
        if (message.transactionIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.transactionIds.length; i++)
                writer.int32(message.transactionIds[i]);
            writer.join();
        }
        /* bool dry_run = 2; */
        if (message.dryRun !== false)
            writer.tag(2, WireType.Varint).bool(message.dryRun);
        /* int32 admin_id = 3; */
        if (message.adminId !== 0)
            writer.tag(3, WireType.Varint).int32(message.adminId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBOBillSyncRequest
 */
export const QBOBillSyncRequest = new QBOBillSyncRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBOBillSyncReport$Type extends MessageType {
    constructor() {
        super("QBOBillSyncReport", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => QBOBillSyncResult },
            { no: 2, name: "succeeded", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "skipped", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "failed", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "unmapped_vendors", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "unmapped_categories", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "unmapped_job_numbers", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.succeeded = 0;
        message.skipped = 0;
        message.failed = 0;
        message.unmappedVendors = [];
        message.unmappedCategories = [];
        message.unmappedJobNumbers = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated QBOBillSyncResult results */ 1:
                    message.results.push(QBOBillSyncResult.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 succeeded */ 2:
                    message.succeeded = reader.int32();
                    break;
                case /* int32 skipped */ 3:
                    message.skipped = reader.int32();
                    break;
                case /* int32 failed */ 4:
                    message.failed = reader.int32();
                    break;
                case /* repeated string unmapped_vendors */ 5:
                    message.unmappedVendors.push(reader.string());
                    break;
                case /* repeated string unmapped_categories */ 6:
                    message.unmappedCategories.push(reader.string());
                    break;
                case /* repeated string unmapped_job_numbers */ 7:
                    message.unmappedJobNumbers.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated QBOBillSyncResult results = 1; */
        for (let i = 0; i < message.results.length; i++)
            QBOBillSyncResult.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 succeeded = 2; */
        if (message.succeeded !== 0)
            writer.tag(2, WireType.Varint).int32(message.succeeded);
        /* int32 skipped = 3; */
        if (message.skipped !== 0)
            writer.tag(3, WireType.Varint).int32(message.skipped);
        /* int32 failed = 4; */
        if (message.failed !== 0)
            writer.tag(4, WireType.Varint).int32(message.failed);
        /* repeated string unmapped_vendors = 5; */
        for (let i = 0; i < message.unmappedVendors.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.unmappedVendors[i]);
        /* repeated string unmapped_categories = 6; */
        for (let i = 0; i < message.unmappedCategories.length; i++)
            writer.tag(6, WireType.LengthDelimited).string(message.unmappedCategories[i]);
        /* repeated string unmapped_job_numbers = 7; */
        for (let i = 0; i < message.unmappedJobNumbers.length; i++)
            writer.tag(7, WireType.LengthDelimited).string(message.unmappedJobNumbers[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBOBillSyncReport
 */
export const QBOBillSyncReport = new QBOBillSyncReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class QBOBillSyncResult$Type extends MessageType {
    constructor() {
        super("QBOBillSyncResult", [
            { no: 1, name: "transaction_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "invoice_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "vendor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "qbo_vendor", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "txn_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "qb_txn_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "detail", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "error_code", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.transactionId = 0;
        message.invoiceNumber = "";
        message.vendor = "";
        message.qboVendor = "";
        message.amount = 0;
        message.txnType = "";
        message.status = "";
        message.qbTxnId = "";
        message.detail = "";
        message.errorCode = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 transaction_id */ 1:
                    message.transactionId = reader.int32();
                    break;
                case /* string invoice_number */ 2:
                    message.invoiceNumber = reader.string();
                    break;
                case /* string vendor */ 3:
                    message.vendor = reader.string();
                    break;
                case /* string qbo_vendor */ 4:
                    message.qboVendor = reader.string();
                    break;
                case /* double amount */ 5:
                    message.amount = reader.double();
                    break;
                case /* string txn_type */ 6:
                    message.txnType = reader.string();
                    break;
                case /* string status */ 7:
                    message.status = reader.string();
                    break;
                case /* string qb_txn_id */ 8:
                    message.qbTxnId = reader.string();
                    break;
                case /* string detail */ 9:
                    message.detail = reader.string();
                    break;
                case /* string error_code */ 10:
                    message.errorCode = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 transaction_id = 1; */
        if (message.transactionId !== 0)
            writer.tag(1, WireType.Varint).int32(message.transactionId);
        /* string invoice_number = 2; */
        if (message.invoiceNumber !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.invoiceNumber);
        /* string vendor = 3; */
        if (message.vendor !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.vendor);
        /* string qbo_vendor = 4; */
        if (message.qboVendor !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.qboVendor);
        /* double amount = 5; */
        if (message.amount !== 0)
            writer.tag(5, WireType.Bit64).double(message.amount);
        /* string txn_type = 6; */
        if (message.txnType !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.txnType);
        /* string status = 7; */
        if (message.status !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.status);
        /* string qb_txn_id = 8; */
        if (message.qbTxnId !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.qbTxnId);
        /* string detail = 9; */
        if (message.detail !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.detail);
        /* string error_code = 10; */
        if (message.errorCode !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.errorCode);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message QBOBillSyncResult
 */
export const QBOBillSyncResult = new QBOBillSyncResult$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeoffReport$Type extends MessageType {
    constructor() {
        super("TimeoffReport", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TimeoffReportLine },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated TimeoffReportLine data */ 1:
                    message.data.push(TimeoffReportLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated TimeoffReportLine data = 1; */
        for (let i = 0; i < message.data.length; i++)
            TimeoffReportLine.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TimeoffReport
 */
export const TimeoffReport = new TimeoffReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProcessedReportRequest$Type extends MessageType {
    constructor() {
        super("ProcessedReportRequest", [
            { no: 1, name: "processed_start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "processed_end_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "timesheet_start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "timesheet_end_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.processedStartDate = "";
        message.processedEndDate = "";
        message.timesheetStartDate = "";
        message.timesheetEndDate = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string processed_start_date */ 1:
                    message.processedStartDate = reader.string();
                    break;
                case /* string processed_end_date */ 2:
                    message.processedEndDate = reader.string();
                    break;
                case /* string timesheet_start_date */ 3:
                    message.timesheetStartDate = reader.string();
                    break;
                case /* string timesheet_end_date */ 4:
                    message.timesheetEndDate = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string processed_start_date = 1; */
        if (message.processedStartDate !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.processedStartDate);
        /* string processed_end_date = 2; */
        if (message.processedEndDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.processedEndDate);
        /* string timesheet_start_date = 3; */
        if (message.timesheetStartDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.timesheetStartDate);
        /* string timesheet_end_date = 4; */
        if (message.timesheetEndDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.timesheetEndDate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProcessedReportRequest
 */
export const ProcessedReportRequest = new ProcessedReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProcessedReport$Type extends MessageType {
    constructor() {
        super("ProcessedReport", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProcessedReportLine },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ProcessedReportLine data */ 1:
                    message.data.push(ProcessedReportLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ProcessedReportLine data = 1; */
        for (let i = 0; i < message.data.length; i++)
            ProcessedReportLine.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ProcessedReport
 */
export const ProcessedReport = new ProcessedReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BillingAuditReport$Type extends MessageType {
    constructor() {
        super("BillingAuditReport", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => BillingAudit },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated BillingAudit data */ 1:
                    message.data.push(BillingAudit.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated BillingAudit data = 1; */
        for (let i = 0; i < message.data.length; i++)
            BillingAudit.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message BillingAuditReport
 */
export const BillingAuditReport = new BillingAuditReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromptPaymentSummary$Type extends MessageType {
    constructor() {
        super("PromptPaymentSummary", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "business_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "user_email", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "payable_award", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 5, name: "forfeited_award", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 6, name: "total_payable", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "payment_terms", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "average_days_to_pay", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "invoices_paid", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "invoices", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.businessName = "";
        message.userEmail = "";
        message.payableAward = 0;
        message.forfeitedAward = 0;
        message.totalPayable = 0;
        message.paymentTerms = "";
        message.averageDaysToPay = 0;
        message.invoicesPaid = 0;
        message.invoices = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* string business_name */ 2:
                    message.businessName = reader.string();
                    break;
                case /* string user_email */ 3:
                    message.userEmail = reader.string();
                    break;
                case /* double payable_award */ 4:
                    message.payableAward = reader.double();
                    break;
                case /* double forfeited_award */ 5:
                    message.forfeitedAward = reader.double();
                    break;
                case /* double total_payable */ 6:
                    message.totalPayable = reader.double();
                    break;
                case /* string payment_terms */ 7:
                    message.paymentTerms = reader.string();
                    break;
                case /* double average_days_to_pay */ 8:
                    message.averageDaysToPay = reader.double();
                    break;
                case /* double invoices_paid */ 9:
                    message.invoicesPaid = reader.double();
                    break;
                case /* int32 invoices */ 10:
                    message.invoices = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* string business_name = 2; */
        if (message.businessName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.businessName);
        /* string user_email = 3; */
        if (message.userEmail !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.userEmail);
        /* double payable_award = 4; */
        if (message.payableAward !== 0)
            writer.tag(4, WireType.Bit64).double(message.payableAward);
        /* double forfeited_award = 5; */
        if (message.forfeitedAward !== 0)
            writer.tag(5, WireType.Bit64).double(message.forfeitedAward);
        /* double total_payable = 6; */
        if (message.totalPayable !== 0)
            writer.tag(6, WireType.Bit64).double(message.totalPayable);
        /* string payment_terms = 7; */
        if (message.paymentTerms !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.paymentTerms);
        /* double average_days_to_pay = 8; */
        if (message.averageDaysToPay !== 0)
            writer.tag(8, WireType.Bit64).double(message.averageDaysToPay);
        /* double invoices_paid = 9; */
        if (message.invoicesPaid !== 0)
            writer.tag(9, WireType.Bit64).double(message.invoicesPaid);
        /* int32 invoices = 10; */
        if (message.invoices !== 0)
            writer.tag(10, WireType.Varint).int32(message.invoices);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PromptPaymentSummary
 */
export const PromptPaymentSummary = new PromptPaymentSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromptPaymentSummaryResponse$Type extends MessageType {
    constructor() {
        super("PromptPaymentSummaryResponse", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PromptPaymentSummary }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PromptPaymentSummary data */ 1:
                    message.data.push(PromptPaymentSummary.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PromptPaymentSummary data = 1; */
        for (let i = 0; i < message.data.length; i++)
            PromptPaymentSummary.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PromptPaymentSummaryResponse
 */
export const PromptPaymentSummaryResponse = new PromptPaymentSummaryResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromptPaymentSummaryRequest$Type extends MessageType {
    constructor() {
        super("PromptPaymentSummaryRequest", [
            { no: 1, name: "start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "end_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "customer_id", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.startDate = "";
        message.endDate = "";
        message.customerId = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string start_date */ 1:
                    message.startDate = reader.string();
                    break;
                case /* string end_date */ 2:
                    message.endDate = reader.string();
                    break;
                case /* repeated int32 customer_id */ 3:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.customerId.push(reader.int32());
                    else
                        message.customerId.push(reader.int32());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string start_date = 1; */
        if (message.startDate !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.startDate);
        /* string end_date = 2; */
        if (message.endDate !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.endDate);
        /* repeated int32 customer_id = 3; */
        if (message.customerId.length) {
            writer.tag(3, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.customerId.length; i++)
                writer.int32(message.customerId[i]);
            writer.join();
        }
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PromptPaymentSummaryRequest
 */
export const PromptPaymentSummaryRequest = new PromptPaymentSummaryRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromptPaymentDetails$Type extends MessageType {
    constructor() {
        super("PromptPaymentDetails", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "business_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 4, name: "billing_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "due_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "payment_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "payable", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 9, name: "payed", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 10, name: "payment_terms", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "days_to_pay", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "possible_award", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 13, name: "payable_award", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 14, name: "forfeited_award", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 15, name: "property_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 16, name: "document_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 17, name: "rebate_amount", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 18, name: "rebate_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "report_until", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "override_reason", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "pending_award", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.businessName = "";
        message.eventId = 0;
        message.billingDate = "";
        message.dueDate = "";
        message.paymentDate = "";
        message.jobNumber = "";
        message.payable = 0;
        message.payed = 0;
        message.paymentTerms = "";
        message.daysToPay = 0;
        message.possibleAward = 0;
        message.payableAward = 0;
        message.forfeitedAward = 0;
        message.propertyId = 0;
        message.documentId = 0;
        message.rebateAmount = 0;
        message.rebateDate = "";
        message.reportUntil = "";
        message.overrideReason = "";
        message.pendingAward = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* string business_name */ 2:
                    message.businessName = reader.string();
                    break;
                case /* int32 event_id */ 3:
                    message.eventId = reader.int32();
                    break;
                case /* string billing_date */ 4:
                    message.billingDate = reader.string();
                    break;
                case /* string due_date */ 5:
                    message.dueDate = reader.string();
                    break;
                case /* string payment_date */ 6:
                    message.paymentDate = reader.string();
                    break;
                case /* string job_number */ 7:
                    message.jobNumber = reader.string();
                    break;
                case /* double payable */ 8:
                    message.payable = reader.double();
                    break;
                case /* double payed */ 9:
                    message.payed = reader.double();
                    break;
                case /* string payment_terms */ 10:
                    message.paymentTerms = reader.string();
                    break;
                case /* int32 days_to_pay */ 11:
                    message.daysToPay = reader.int32();
                    break;
                case /* double possible_award */ 12:
                    message.possibleAward = reader.double();
                    break;
                case /* double payable_award */ 13:
                    message.payableAward = reader.double();
                    break;
                case /* double forfeited_award */ 14:
                    message.forfeitedAward = reader.double();
                    break;
                case /* int32 property_id */ 15:
                    message.propertyId = reader.int32();
                    break;
                case /* int32 document_id */ 16:
                    message.documentId = reader.int32();
                    break;
                case /* double rebate_amount */ 17:
                    message.rebateAmount = reader.double();
                    break;
                case /* string rebate_date */ 18:
                    message.rebateDate = reader.string();
                    break;
                case /* string report_until */ 19:
                    message.reportUntil = reader.string();
                    break;
                case /* string override_reason */ 20:
                    message.overrideReason = reader.string();
                    break;
                case /* double pending_award */ 21:
                    message.pendingAward = reader.double();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* string business_name = 2; */
        if (message.businessName !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.businessName);
        /* int32 event_id = 3; */
        if (message.eventId !== 0)
            writer.tag(3, WireType.Varint).int32(message.eventId);
        /* string billing_date = 4; */
        if (message.billingDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.billingDate);
        /* string due_date = 5; */
        if (message.dueDate !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.dueDate);
        /* string payment_date = 6; */
        if (message.paymentDate !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.paymentDate);
        /* string job_number = 7; */
        if (message.jobNumber !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.jobNumber);
        /* double payable = 8; */
        if (message.payable !== 0)
            writer.tag(8, WireType.Bit64).double(message.payable);
        /* double payed = 9; */
        if (message.payed !== 0)
            writer.tag(9, WireType.Bit64).double(message.payed);
        /* string payment_terms = 10; */
        if (message.paymentTerms !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.paymentTerms);
        /* int32 days_to_pay = 11; */
        if (message.daysToPay !== 0)
            writer.tag(11, WireType.Varint).int32(message.daysToPay);
        /* double possible_award = 12; */
        if (message.possibleAward !== 0)
            writer.tag(12, WireType.Bit64).double(message.possibleAward);
        /* double payable_award = 13; */
        if (message.payableAward !== 0)
            writer.tag(13, WireType.Bit64).double(message.payableAward);
        /* double forfeited_award = 14; */
        if (message.forfeitedAward !== 0)
            writer.tag(14, WireType.Bit64).double(message.forfeitedAward);
        /* int32 property_id = 15; */
        if (message.propertyId !== 0)
            writer.tag(15, WireType.Varint).int32(message.propertyId);
        /* int32 document_id = 16; */
        if (message.documentId !== 0)
            writer.tag(16, WireType.Varint).int32(message.documentId);
        /* double rebate_amount = 17; */
        if (message.rebateAmount !== 0)
            writer.tag(17, WireType.Bit64).double(message.rebateAmount);
        /* string rebate_date = 18; */
        if (message.rebateDate !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.rebateDate);
        /* string report_until = 19; */
        if (message.reportUntil !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.reportUntil);
        /* string override_reason = 20; */
        if (message.overrideReason !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.overrideReason);
        /* double pending_award = 21; */
        if (message.pendingAward !== 0)
            writer.tag(21, WireType.Bit64).double(message.pendingAward);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PromptPaymentDetails
 */
export const PromptPaymentDetails = new PromptPaymentDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromptPaymentDetailsResponse$Type extends MessageType {
    constructor() {
        super("PromptPaymentDetailsResponse", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PromptPaymentDetails }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PromptPaymentDetails data */ 1:
                    message.data.push(PromptPaymentDetails.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PromptPaymentDetails data = 1; */
        for (let i = 0; i < message.data.length; i++)
            PromptPaymentDetails.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PromptPaymentDetailsResponse
 */
export const PromptPaymentDetailsResponse = new PromptPaymentDetailsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromptPaymentListFinalized$Type extends MessageType {
    constructor() {
        super("PromptPaymentListFinalized", [
            { no: 1, name: "payment_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "payee_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "amount_collected", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 4, name: "rebate_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.paymentId = 0;
        message.payeeUserId = 0;
        message.amountCollected = 0;
        message.rebateDate = "";
        message.dateRange = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 payment_id */ 1:
                    message.paymentId = reader.int32();
                    break;
                case /* int32 payee_user_id */ 2:
                    message.payeeUserId = reader.int32();
                    break;
                case /* double amount_collected */ 3:
                    message.amountCollected = reader.double();
                    break;
                case /* string rebate_date */ 4:
                    message.rebateDate = reader.string();
                    break;
                case /* repeated string date_range */ 5:
                    message.dateRange.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 payment_id = 1; */
        if (message.paymentId !== 0)
            writer.tag(1, WireType.Varint).int32(message.paymentId);
        /* int32 payee_user_id = 2; */
        if (message.payeeUserId !== 0)
            writer.tag(2, WireType.Varint).int32(message.payeeUserId);
        /* double amount_collected = 3; */
        if (message.amountCollected !== 0)
            writer.tag(3, WireType.Bit64).double(message.amountCollected);
        /* string rebate_date = 4; */
        if (message.rebateDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.rebateDate);
        /* repeated string date_range = 5; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.dateRange[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PromptPaymentListFinalized
 */
export const PromptPaymentListFinalized = new PromptPaymentListFinalized$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PromptPaymentListFinalizedResponse$Type extends MessageType {
    constructor() {
        super("PromptPaymentListFinalizedResponse", [
            { no: 1, name: "data", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PromptPaymentListFinalized }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.data = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PromptPaymentListFinalized data */ 1:
                    message.data.push(PromptPaymentListFinalized.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PromptPaymentListFinalized data = 1; */
        for (let i = 0; i < message.data.length; i++)
            PromptPaymentListFinalized.internalBinaryWrite(message.data[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PromptPaymentListFinalizedResponse
 */
export const PromptPaymentListFinalizedResponse = new PromptPaymentListFinalizedResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportFile$Type extends MessageType {
    constructor() {
        super("ReportFile", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "presented_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "bucket", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "mime_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "creation_dt", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "create_time", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "owner_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 11, name: "geolocation_lat", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "geolocation_lng", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 13, name: "classification_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "classification_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "without_limit", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 17, name: "page_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 18, name: "order_by", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "order_dir", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.fileId = 0;
        message.presentedName = "";
        message.name = "";
        message.bucket = "";
        message.mimeType = "";
        message.creationDt = "";
        message.createTime = "";
        message.ownerId = 0;
        message.eventId = 0;
        message.geolocationLat = 0;
        message.geolocationLng = 0;
        message.classificationId = 0;
        message.classificationName = "";
        message.fieldMask = [];
        message.withoutLimit = false;
        message.pageNumber = 0;
        message.orderBy = "";
        message.orderDir = "";
        message.idList = "";
        message.dateTarget = [];
        message.dateRange = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 file_id */ 2:
                    message.fileId = reader.int32();
                    break;
                case /* string presented_name */ 3:
                    message.presentedName = reader.string();
                    break;
                case /* string name */ 4:
                    message.name = reader.string();
                    break;
                case /* string bucket */ 5:
                    message.bucket = reader.string();
                    break;
                case /* string mime_type */ 6:
                    message.mimeType = reader.string();
                    break;
                case /* string creation_dt */ 7:
                    message.creationDt = reader.string();
                    break;
                case /* string create_time */ 8:
                    message.createTime = reader.string();
                    break;
                case /* int32 owner_id */ 9:
                    message.ownerId = reader.int32();
                    break;
                case /* int32 event_id */ 10:
                    message.eventId = reader.int32();
                    break;
                case /* float geolocation_lat */ 11:
                    message.geolocationLat = reader.float();
                    break;
                case /* float geolocation_lng */ 12:
                    message.geolocationLng = reader.float();
                    break;
                case /* int32 classification_id */ 13:
                    message.classificationId = reader.int32();
                    break;
                case /* string classification_name */ 14:
                    message.classificationName = reader.string();
                    break;
                case /* repeated string field_mask */ 15:
                    message.fieldMask.push(reader.string());
                    break;
                case /* bool without_limit */ 16:
                    message.withoutLimit = reader.bool();
                    break;
                case /* int32 page_number */ 17:
                    message.pageNumber = reader.int32();
                    break;
                case /* string order_by */ 18:
                    message.orderBy = reader.string();
                    break;
                case /* string order_dir */ 19:
                    message.orderDir = reader.string();
                    break;
                case /* string id_list */ 20:
                    message.idList = reader.string();
                    break;
                case /* repeated string date_target */ 21:
                    message.dateTarget.push(reader.string());
                    break;
                case /* repeated string date_range */ 22:
                    message.dateRange.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 file_id = 2; */
        if (message.fileId !== 0)
            writer.tag(2, WireType.Varint).int32(message.fileId);
        /* string presented_name = 3; */
        if (message.presentedName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.presentedName);
        /* string name = 4; */
        if (message.name !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.name);
        /* string bucket = 5; */
        if (message.bucket !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.bucket);
        /* string mime_type = 6; */
        if (message.mimeType !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.mimeType);
        /* string creation_dt = 7; */
        if (message.creationDt !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.creationDt);
        /* string create_time = 8; */
        if (message.createTime !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.createTime);
        /* int32 owner_id = 9; */
        if (message.ownerId !== 0)
            writer.tag(9, WireType.Varint).int32(message.ownerId);
        /* int32 event_id = 10; */
        if (message.eventId !== 0)
            writer.tag(10, WireType.Varint).int32(message.eventId);
        /* float geolocation_lat = 11; */
        if (message.geolocationLat !== 0)
            writer.tag(11, WireType.Bit32).float(message.geolocationLat);
        /* float geolocation_lng = 12; */
        if (message.geolocationLng !== 0)
            writer.tag(12, WireType.Bit32).float(message.geolocationLng);
        /* int32 classification_id = 13; */
        if (message.classificationId !== 0)
            writer.tag(13, WireType.Varint).int32(message.classificationId);
        /* string classification_name = 14; */
        if (message.classificationName !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.classificationName);
        /* repeated string field_mask = 15; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(15, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* bool without_limit = 16; */
        if (message.withoutLimit !== false)
            writer.tag(16, WireType.Varint).bool(message.withoutLimit);
        /* int32 page_number = 17; */
        if (message.pageNumber !== 0)
            writer.tag(17, WireType.Varint).int32(message.pageNumber);
        /* string order_by = 18; */
        if (message.orderBy !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.orderBy);
        /* string order_dir = 19; */
        if (message.orderDir !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.orderDir);
        /* string id_list = 20; */
        if (message.idList !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.idList);
        /* repeated string date_target = 21; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(21, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* repeated string date_range = 22; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(22, WireType.LengthDelimited).string(message.dateRange[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReportFile
 */
export const ReportFile = new ReportFile$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ReportFileList$Type extends MessageType {
    constructor() {
        super("ReportFileList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ReportFile },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated ReportFile results */ 1:
                    message.results.push(ReportFile.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated ReportFile results = 1; */
        for (let i = 0; i < message.results.length; i++)
            ReportFile.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message ReportFileList
 */
export const ReportFileList = new ReportFileList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Report$Type extends MessageType {
    constructor() {
        super("Report", [
            { no: 1, name: "id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "file_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "presented_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "classification_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 5, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.id = 0;
        message.fileId = 0;
        message.presentedName = "";
        message.classificationId = 0;
        message.fieldMask = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 id */ 1:
                    message.id = reader.int32();
                    break;
                case /* int32 file_id */ 2:
                    message.fileId = reader.int32();
                    break;
                case /* string presented_name */ 3:
                    message.presentedName = reader.string();
                    break;
                case /* int32 classification_id */ 4:
                    message.classificationId = reader.int32();
                    break;
                case /* repeated string field_mask */ 5:
                    message.fieldMask.push(reader.string());
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 id = 1; */
        if (message.id !== 0)
            writer.tag(1, WireType.Varint).int32(message.id);
        /* int32 file_id = 2; */
        if (message.fileId !== 0)
            writer.tag(2, WireType.Varint).int32(message.fileId);
        /* string presented_name = 3; */
        if (message.presentedName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.presentedName);
        /* int32 classification_id = 4; */
        if (message.classificationId !== 0)
            writer.tag(4, WireType.Varint).int32(message.classificationId);
        /* repeated string field_mask = 5; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(5, WireType.LengthDelimited).string(message.fieldMask[i]);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message Report
 */
export const Report = new Report$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimesheetAudit$Type extends MessageType {
    constructor() {
        super("TimesheetAudit", [
            { no: 1, name: "day", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "time_in", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "time_out", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "total_hours", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "travel_time", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "mileage", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "perdiem", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "hotel_lodging", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.day = "";
        message.timeIn = "";
        message.timeOut = "";
        message.totalHours = 0;
        message.travelTime = 0;
        message.mileage = 0;
        message.perdiem = 0;
        message.hotelLodging = 0;
        message.status = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string day */ 1:
                    message.day = reader.string();
                    break;
                case /* string time_in */ 2:
                    message.timeIn = reader.string();
                    break;
                case /* string time_out */ 3:
                    message.timeOut = reader.string();
                    break;
                case /* float total_hours */ 4:
                    message.totalHours = reader.float();
                    break;
                case /* float travel_time */ 5:
                    message.travelTime = reader.float();
                    break;
                case /* float mileage */ 6:
                    message.mileage = reader.float();
                    break;
                case /* float perdiem */ 7:
                    message.perdiem = reader.float();
                    break;
                case /* float hotel_lodging */ 8:
                    message.hotelLodging = reader.float();
                    break;
                case /* string status */ 9:
                    message.status = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string day = 1; */
        if (message.day !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.day);
        /* string time_in = 2; */
        if (message.timeIn !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.timeIn);
        /* string time_out = 3; */
        if (message.timeOut !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.timeOut);
        /* float total_hours = 4; */
        if (message.totalHours !== 0)
            writer.tag(4, WireType.Bit32).float(message.totalHours);
        /* float travel_time = 5; */
        if (message.travelTime !== 0)
            writer.tag(5, WireType.Bit32).float(message.travelTime);
        /* float mileage = 6; */
        if (message.mileage !== 0)
            writer.tag(6, WireType.Bit32).float(message.mileage);
        /* float perdiem = 7; */
        if (message.perdiem !== 0)
            writer.tag(7, WireType.Bit32).float(message.perdiem);
        /* float hotel_lodging = 8; */
        if (message.hotelLodging !== 0)
            writer.tag(8, WireType.Bit32).float(message.hotelLodging);
        /* string status = 9; */
        if (message.status !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.status);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TimesheetAudit
 */
export const TimesheetAudit = new TimesheetAudit$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimesheetAuditReport$Type extends MessageType {
    constructor() {
        super("TimesheetAuditReport", [
            { no: 1, name: "audits", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TimesheetAudit },
            { no: 2, name: "total_hours", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "total_travel_time", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "total_mileage", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "total_per_diem", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.audits = [];
        message.totalHours = 0;
        message.totalTravelTime = 0;
        message.totalMileage = 0;
        message.totalPerDiem = 0;
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated TimesheetAudit audits */ 1:
                    message.audits.push(TimesheetAudit.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* float total_hours */ 2:
                    message.totalHours = reader.float();
                    break;
                case /* float total_travel_time */ 3:
                    message.totalTravelTime = reader.float();
                    break;
                case /* float total_mileage */ 4:
                    message.totalMileage = reader.float();
                    break;
                case /* float total_per_diem */ 5:
                    message.totalPerDiem = reader.float();
                    break;
                case /* int32 user_id */ 6:
                    message.userId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated TimesheetAudit audits = 1; */
        for (let i = 0; i < message.audits.length; i++)
            TimesheetAudit.internalBinaryWrite(message.audits[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* float total_hours = 2; */
        if (message.totalHours !== 0)
            writer.tag(2, WireType.Bit32).float(message.totalHours);
        /* float total_travel_time = 3; */
        if (message.totalTravelTime !== 0)
            writer.tag(3, WireType.Bit32).float(message.totalTravelTime);
        /* float total_mileage = 4; */
        if (message.totalMileage !== 0)
            writer.tag(4, WireType.Bit32).float(message.totalMileage);
        /* float total_per_diem = 5; */
        if (message.totalPerDiem !== 0)
            writer.tag(5, WireType.Bit32).float(message.totalPerDiem);
        /* int32 user_id = 6; */
        if (message.userId !== 0)
            writer.tag(6, WireType.Varint).int32(message.userId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TimesheetAuditReport
 */
export const TimesheetAuditReport = new TimesheetAuditReport$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimesheetAuditReportCollection$Type extends MessageType {
    constructor() {
        super("TimesheetAuditReportCollection", [
            { no: 1, name: "reports", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TimesheetAuditReport },
            { no: 2, name: "total_employees", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "grand_total_hours", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "grand_total_travel_time", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "grand_total_mileage", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "grand_total_per_diem", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "start_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "end_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.reports = [];
        message.totalEmployees = 0;
        message.grandTotalHours = 0;
        message.grandTotalTravelTime = 0;
        message.grandTotalMileage = 0;
        message.grandTotalPerDiem = 0;
        message.startDate = "";
        message.endDate = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated TimesheetAuditReport reports */ 1:
                    message.reports.push(TimesheetAuditReport.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_employees */ 2:
                    message.totalEmployees = reader.int32();
                    break;
                case /* float grand_total_hours */ 3:
                    message.grandTotalHours = reader.float();
                    break;
                case /* float grand_total_travel_time */ 4:
                    message.grandTotalTravelTime = reader.float();
                    break;
                case /* float grand_total_mileage */ 5:
                    message.grandTotalMileage = reader.float();
                    break;
                case /* float grand_total_per_diem */ 6:
                    message.grandTotalPerDiem = reader.float();
                    break;
                case /* string start_date */ 7:
                    message.startDate = reader.string();
                    break;
                case /* string end_date */ 8:
                    message.endDate = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated TimesheetAuditReport reports = 1; */
        for (let i = 0; i < message.reports.length; i++)
            TimesheetAuditReport.internalBinaryWrite(message.reports[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_employees = 2; */
        if (message.totalEmployees !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalEmployees);
        /* float grand_total_hours = 3; */
        if (message.grandTotalHours !== 0)
            writer.tag(3, WireType.Bit32).float(message.grandTotalHours);
        /* float grand_total_travel_time = 4; */
        if (message.grandTotalTravelTime !== 0)
            writer.tag(4, WireType.Bit32).float(message.grandTotalTravelTime);
        /* float grand_total_mileage = 5; */
        if (message.grandTotalMileage !== 0)
            writer.tag(5, WireType.Bit32).float(message.grandTotalMileage);
        /* float grand_total_per_diem = 6; */
        if (message.grandTotalPerDiem !== 0)
            writer.tag(6, WireType.Bit32).float(message.grandTotalPerDiem);
        /* string start_date = 7; */
        if (message.startDate !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.startDate);
        /* string end_date = 8; */
        if (message.endDate !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.endDate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TimesheetAuditReportCollection
 */
export const TimesheetAuditReportCollection = new TimesheetAuditReportCollection$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmployeeKpiRequest$Type extends MessageType {
    constructor() {
        super("EmployeeKpiRequest", [
            { no: 1, name: "employee_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "date_range", kind: "message", T: () => DateRange }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.employeeId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 employee_id */ 1:
                    message.employeeId = reader.int32();
                    break;
                case /* DateRange date_range */ 2:
                    message.dateRange = DateRange.internalBinaryRead(reader, reader.uint32(), options, message.dateRange);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 employee_id = 1; */
        if (message.employeeId !== 0)
            writer.tag(1, WireType.Varint).int32(message.employeeId);
        /* DateRange date_range = 2; */
        if (message.dateRange)
            DateRange.internalBinaryWrite(message.dateRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EmployeeKpiRequest
 */
export const EmployeeKpiRequest = new EmployeeKpiRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmployeeKpi$Type extends MessageType {
    constructor() {
        super("EmployeeKpi", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "metric_average_ticket", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 3, name: "metric_income", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "metric_average_billable", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "metric_average_travel_time", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "metric_average_job_time", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "jobs_details", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => JobDetails }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        message.metricAverageTicket = 0;
        message.metricIncome = 0;
        message.metricAverageBillable = 0;
        message.metricAverageTravelTime = 0;
        message.metricAverageJobTime = 0;
        message.jobsDetails = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* float metric_average_ticket */ 2:
                    message.metricAverageTicket = reader.float();
                    break;
                case /* float metric_income */ 3:
                    message.metricIncome = reader.float();
                    break;
                case /* float metric_average_billable */ 4:
                    message.metricAverageBillable = reader.float();
                    break;
                case /* float metric_average_travel_time */ 5:
                    message.metricAverageTravelTime = reader.float();
                    break;
                case /* float metric_average_job_time */ 6:
                    message.metricAverageJobTime = reader.float();
                    break;
                case /* repeated JobDetails jobs_details */ 7:
                    message.jobsDetails.push(JobDetails.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* float metric_average_ticket = 2; */
        if (message.metricAverageTicket !== 0)
            writer.tag(2, WireType.Bit32).float(message.metricAverageTicket);
        /* float metric_income = 3; */
        if (message.metricIncome !== 0)
            writer.tag(3, WireType.Bit32).float(message.metricIncome);
        /* float metric_average_billable = 4; */
        if (message.metricAverageBillable !== 0)
            writer.tag(4, WireType.Bit32).float(message.metricAverageBillable);
        /* float metric_average_travel_time = 5; */
        if (message.metricAverageTravelTime !== 0)
            writer.tag(5, WireType.Bit32).float(message.metricAverageTravelTime);
        /* float metric_average_job_time = 6; */
        if (message.metricAverageJobTime !== 0)
            writer.tag(6, WireType.Bit32).float(message.metricAverageJobTime);
        /* repeated JobDetails jobs_details = 7; */
        for (let i = 0; i < message.jobsDetails.length; i++)
            JobDetails.internalBinaryWrite(message.jobsDetails[i], writer.tag(7, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EmployeeKpi
 */
export const EmployeeKpi = new EmployeeKpi$Type();
// @generated message type with reflection information, may provide speed optimized methods
class JobDetails$Type extends MessageType {
    constructor() {
        super("JobDetails", [
            { no: 1, name: "job_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "job_number", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "invoice_total_amount", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 4, name: "user_billable_hours", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "user_non_billable_hours", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "user_job_time", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "user_travel_time", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 8, name: "total_job_billable_hours", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 9, name: "total_job_non_billable_hours", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 10, name: "is_callback", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobName = "";
        message.jobNumber = 0;
        message.invoiceTotalAmount = 0;
        message.userBillableHours = 0;
        message.userNonBillableHours = 0;
        message.userJobTime = 0;
        message.userTravelTime = 0;
        message.totalJobBillableHours = 0;
        message.totalJobNonBillableHours = 0;
        message.isCallback = false;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string job_name */ 1:
                    message.jobName = reader.string();
                    break;
                case /* int32 job_number */ 2:
                    message.jobNumber = reader.int32();
                    break;
                case /* float invoice_total_amount */ 3:
                    message.invoiceTotalAmount = reader.float();
                    break;
                case /* float user_billable_hours */ 4:
                    message.userBillableHours = reader.float();
                    break;
                case /* float user_non_billable_hours */ 5:
                    message.userNonBillableHours = reader.float();
                    break;
                case /* float user_job_time */ 6:
                    message.userJobTime = reader.float();
                    break;
                case /* float user_travel_time */ 7:
                    message.userTravelTime = reader.float();
                    break;
                case /* float total_job_billable_hours */ 8:
                    message.totalJobBillableHours = reader.float();
                    break;
                case /* float total_job_non_billable_hours */ 9:
                    message.totalJobNonBillableHours = reader.float();
                    break;
                case /* bool is_callback */ 10:
                    message.isCallback = reader.bool();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string job_name = 1; */
        if (message.jobName !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.jobName);
        /* int32 job_number = 2; */
        if (message.jobNumber !== 0)
            writer.tag(2, WireType.Varint).int32(message.jobNumber);
        /* float invoice_total_amount = 3; */
        if (message.invoiceTotalAmount !== 0)
            writer.tag(3, WireType.Bit32).float(message.invoiceTotalAmount);
        /* float user_billable_hours = 4; */
        if (message.userBillableHours !== 0)
            writer.tag(4, WireType.Bit32).float(message.userBillableHours);
        /* float user_non_billable_hours = 5; */
        if (message.userNonBillableHours !== 0)
            writer.tag(5, WireType.Bit32).float(message.userNonBillableHours);
        /* float user_job_time = 6; */
        if (message.userJobTime !== 0)
            writer.tag(6, WireType.Bit32).float(message.userJobTime);
        /* float user_travel_time = 7; */
        if (message.userTravelTime !== 0)
            writer.tag(7, WireType.Bit32).float(message.userTravelTime);
        /* float total_job_billable_hours = 8; */
        if (message.totalJobBillableHours !== 0)
            writer.tag(8, WireType.Bit32).float(message.totalJobBillableHours);
        /* float total_job_non_billable_hours = 9; */
        if (message.totalJobNonBillableHours !== 0)
            writer.tag(9, WireType.Bit32).float(message.totalJobNonBillableHours);
        /* bool is_callback = 10; */
        if (message.isCallback !== false)
            writer.tag(10, WireType.Varint).bool(message.isCallback);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message JobDetails
 */
export const JobDetails = new JobDetails$Type();
// @generated message type with reflection information, may provide speed optimized methods
class KpiReportRequest$Type extends MessageType {
    constructor() {
        super("KpiReportRequest", [
            { no: 1, name: "user_ids", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "date_range", kind: "message", T: () => DateRange }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userIds = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated int32 user_ids */ 1:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.userIds.push(reader.int32());
                    else
                        message.userIds.push(reader.int32());
                    break;
                case /* DateRange date_range */ 2:
                    message.dateRange = DateRange.internalBinaryRead(reader, reader.uint32(), options, message.dateRange);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated int32 user_ids = 1; */
        if (message.userIds.length) {
            writer.tag(1, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.userIds.length; i++)
                writer.int32(message.userIds[i]);
            writer.join();
        }
        /* DateRange date_range = 2; */
        if (message.dateRange)
            DateRange.internalBinaryWrite(message.dateRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message KpiReportRequest
 */
export const KpiReportRequest = new KpiReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmployeeKpiList$Type extends MessageType {
    constructor() {
        super("EmployeeKpiList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EmployeeKpi },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated EmployeeKpi results */ 1:
                    message.results.push(EmployeeKpi.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated EmployeeKpi results = 1; */
        for (let i = 0; i < message.results.length; i++)
            EmployeeKpi.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EmployeeKpiList
 */
export const EmployeeKpiList = new EmployeeKpiList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmployeeHoursRevenue$Type extends MessageType {
    constructor() {
        super("EmployeeHoursRevenue", [
            { no: 1, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "technician_user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "tech_assist", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 4, name: "total_billable_time", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 5, name: "total_non_billable_time", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 6, name: "most_recent_invoice_amount", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 7, name: "date_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "is_callback", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 9, name: "technician_user_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "event_id_list", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "date_range", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "date_target", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 13, name: "field_mask", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "event_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "total_job_time", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 16, name: "total_travel_time", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.eventId = 0;
        message.technicianUserId = 0;
        message.techAssist = false;
        message.totalBillableTime = 0;
        message.totalNonBillableTime = 0;
        message.mostRecentInvoiceAmount = 0;
        message.dateStarted = "";
        message.isCallback = false;
        message.technicianUserIdList = "";
        message.eventIdList = "";
        message.dateRange = [];
        message.dateTarget = [];
        message.fieldMask = [];
        message.eventName = "";
        message.totalJobTime = 0;
        message.totalTravelTime = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 event_id */ 1:
                    message.eventId = reader.int32();
                    break;
                case /* int32 technician_user_id */ 2:
                    message.technicianUserId = reader.int32();
                    break;
                case /* bool tech_assist */ 3:
                    message.techAssist = reader.bool();
                    break;
                case /* float total_billable_time */ 4:
                    message.totalBillableTime = reader.float();
                    break;
                case /* float total_non_billable_time */ 5:
                    message.totalNonBillableTime = reader.float();
                    break;
                case /* float most_recent_invoice_amount */ 6:
                    message.mostRecentInvoiceAmount = reader.float();
                    break;
                case /* string date_started */ 7:
                    message.dateStarted = reader.string();
                    break;
                case /* bool is_callback */ 8:
                    message.isCallback = reader.bool();
                    break;
                case /* string technician_user_id_list */ 9:
                    message.technicianUserIdList = reader.string();
                    break;
                case /* string event_id_list */ 10:
                    message.eventIdList = reader.string();
                    break;
                case /* repeated string date_range */ 11:
                    message.dateRange.push(reader.string());
                    break;
                case /* repeated string date_target */ 12:
                    message.dateTarget.push(reader.string());
                    break;
                case /* repeated string field_mask */ 13:
                    message.fieldMask.push(reader.string());
                    break;
                case /* string event_name */ 14:
                    message.eventName = reader.string();
                    break;
                case /* float total_job_time */ 15:
                    message.totalJobTime = reader.float();
                    break;
                case /* float total_travel_time */ 16:
                    message.totalTravelTime = reader.float();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 event_id = 1; */
        if (message.eventId !== 0)
            writer.tag(1, WireType.Varint).int32(message.eventId);
        /* int32 technician_user_id = 2; */
        if (message.technicianUserId !== 0)
            writer.tag(2, WireType.Varint).int32(message.technicianUserId);
        /* bool tech_assist = 3; */
        if (message.techAssist !== false)
            writer.tag(3, WireType.Varint).bool(message.techAssist);
        /* float total_billable_time = 4; */
        if (message.totalBillableTime !== 0)
            writer.tag(4, WireType.Bit32).float(message.totalBillableTime);
        /* float total_non_billable_time = 5; */
        if (message.totalNonBillableTime !== 0)
            writer.tag(5, WireType.Bit32).float(message.totalNonBillableTime);
        /* float most_recent_invoice_amount = 6; */
        if (message.mostRecentInvoiceAmount !== 0)
            writer.tag(6, WireType.Bit32).float(message.mostRecentInvoiceAmount);
        /* string date_started = 7; */
        if (message.dateStarted !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.dateStarted);
        /* bool is_callback = 8; */
        if (message.isCallback !== false)
            writer.tag(8, WireType.Varint).bool(message.isCallback);
        /* string technician_user_id_list = 9; */
        if (message.technicianUserIdList !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.technicianUserIdList);
        /* string event_id_list = 10; */
        if (message.eventIdList !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.eventIdList);
        /* repeated string date_range = 11; */
        for (let i = 0; i < message.dateRange.length; i++)
            writer.tag(11, WireType.LengthDelimited).string(message.dateRange[i]);
        /* repeated string date_target = 12; */
        for (let i = 0; i < message.dateTarget.length; i++)
            writer.tag(12, WireType.LengthDelimited).string(message.dateTarget[i]);
        /* repeated string field_mask = 13; */
        for (let i = 0; i < message.fieldMask.length; i++)
            writer.tag(13, WireType.LengthDelimited).string(message.fieldMask[i]);
        /* string event_name = 14; */
        if (message.eventName !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.eventName);
        /* float total_job_time = 15; */
        if (message.totalJobTime !== 0)
            writer.tag(15, WireType.Bit32).float(message.totalJobTime);
        /* float total_travel_time = 16; */
        if (message.totalTravelTime !== 0)
            writer.tag(16, WireType.Bit32).float(message.totalTravelTime);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EmployeeHoursRevenue
 */
export const EmployeeHoursRevenue = new EmployeeHoursRevenue$Type();
// @generated message type with reflection information, may provide speed optimized methods
class EmployeeHoursRevenueList$Type extends MessageType {
    constructor() {
        super("EmployeeHoursRevenueList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => EmployeeHoursRevenue },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated EmployeeHoursRevenue results */ 1:
                    message.results.push(EmployeeHoursRevenue.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated EmployeeHoursRevenue results = 1; */
        for (let i = 0; i < message.results.length; i++)
            EmployeeHoursRevenue.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message EmployeeHoursRevenueList
 */
export const EmployeeHoursRevenueList = new EmployeeHoursRevenueList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class WeeklyEmployeeReportRequest$Type extends MessageType {
    constructor() {
        super("WeeklyEmployeeReportRequest", [
            { no: 1, name: "status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "department_id_list", kind: "scalar", repeat: 1 /*RepeatType.PACKED*/, T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "date_range", kind: "message", T: () => DateRange }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.status = "";
        message.departmentIdList = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string status */ 1:
                    message.status = reader.string();
                    break;
                case /* repeated int32 department_id_list */ 2:
                    if (wireType === WireType.LengthDelimited)
                        for (let e = reader.int32() + reader.pos; reader.pos < e;)
                            message.departmentIdList.push(reader.int32());
                    else
                        message.departmentIdList.push(reader.int32());
                    break;
                case /* DateRange date_range */ 3:
                    message.dateRange = DateRange.internalBinaryRead(reader, reader.uint32(), options, message.dateRange);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string status = 1; */
        if (message.status !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.status);
        /* repeated int32 department_id_list = 2; */
        if (message.departmentIdList.length) {
            writer.tag(2, WireType.LengthDelimited).fork();
            for (let i = 0; i < message.departmentIdList.length; i++)
                writer.int32(message.departmentIdList[i]);
            writer.join();
        }
        /* DateRange date_range = 3; */
        if (message.dateRange)
            DateRange.internalBinaryWrite(message.dateRange, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message WeeklyEmployeeReportRequest
 */
export const WeeklyEmployeeReportRequest = new WeeklyEmployeeReportRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeOffMetricRequest$Type extends MessageType {
    constructor() {
        super("TimeOffMetricRequest", [
            { no: 1, name: "user_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "date_range", kind: "message", T: () => DateRange }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 user_id */ 1:
                    message.userId = reader.int32();
                    break;
                case /* DateRange date_range */ 2:
                    message.dateRange = DateRange.internalBinaryRead(reader, reader.uint32(), options, message.dateRange);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 user_id = 1; */
        if (message.userId !== 0)
            writer.tag(1, WireType.Varint).int32(message.userId);
        /* DateRange date_range = 2; */
        if (message.dateRange)
            DateRange.internalBinaryWrite(message.dateRange, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TimeOffMetricRequest
 */
export const TimeOffMetricRequest = new TimeOffMetricRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeOffMetric$Type extends MessageType {
    constructor() {
        super("TimeOffMetric", [
            { no: 1, name: "sum_non_pto_time", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 2, name: "sum_pto_time", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 3, name: "time_off_approved", kind: "message", T: () => TimeoffRequestList }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.sumNonPtoTime = 0;
        message.sumPtoTime = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* double sum_non_pto_time */ 1:
                    message.sumNonPtoTime = reader.double();
                    break;
                case /* double sum_pto_time */ 2:
                    message.sumPtoTime = reader.double();
                    break;
                case /* TimeoffRequestList time_off_approved */ 3:
                    message.timeOffApproved = TimeoffRequestList.internalBinaryRead(reader, reader.uint32(), options, message.timeOffApproved);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* double sum_non_pto_time = 1; */
        if (message.sumNonPtoTime !== 0)
            writer.tag(1, WireType.Bit64).double(message.sumNonPtoTime);
        /* double sum_pto_time = 2; */
        if (message.sumPtoTime !== 0)
            writer.tag(2, WireType.Bit64).double(message.sumPtoTime);
        /* TimeoffRequestList time_off_approved = 3; */
        if (message.timeOffApproved)
            TimeoffRequestList.internalBinaryWrite(message.timeOffApproved, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TimeOffMetric
 */
export const TimeOffMetric = new TimeOffMetric$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallbackMetrics$Type extends MessageType {
    constructor() {
        super("CallbackMetrics", [
            { no: 1, name: "jobs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => CallbackSummary }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobs = [];
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated CallbackSummary jobs */ 1:
                    message.jobs.push(CallbackSummary.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated CallbackSummary jobs = 1; */
        for (let i = 0; i < message.jobs.length; i++)
            CallbackSummary.internalBinaryWrite(message.jobs[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CallbackMetrics
 */
export const CallbackMetrics = new CallbackMetrics$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CallbackSummary$Type extends MessageType {
    constructor() {
        super("CallbackSummary", [
            { no: 1, name: "job_number", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "summary_a", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "summary_b", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "event_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.jobNumber = "";
        message.summaryA = "";
        message.summaryB = "";
        message.eventId = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string job_number */ 1:
                    message.jobNumber = reader.string();
                    break;
                case /* string summary_a */ 2:
                    message.summaryA = reader.string();
                    break;
                case /* string summary_b */ 3:
                    message.summaryB = reader.string();
                    break;
                case /* int32 event_id */ 4:
                    message.eventId = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string job_number = 1; */
        if (message.jobNumber !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.jobNumber);
        /* string summary_a = 2; */
        if (message.summaryA !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.summaryA);
        /* string summary_b = 3; */
        if (message.summaryB !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.summaryB);
        /* int32 event_id = 4; */
        if (message.eventId !== 0)
            writer.tag(4, WireType.Varint).int32(message.eventId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message CallbackSummary
 */
export const CallbackSummary = new CallbackSummary$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PayoutPerJob$Type extends MessageType {
    constructor() {
        super("PayoutPerJob", [
            { no: 1, name: "invoice_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 2, name: "customer_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 3, name: "invoice_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "job_completed_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "customer_firstname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "customer_lastname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "mat_equip_po", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 10, name: "total", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 11, name: "balance", kind: "scalar", T: 2 /*ScalarType.FLOAT*/ },
            { no: 12, name: "lead_generated_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 13, name: "sold_by", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 14, name: "all_techs_ids", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 15, name: "all_techs", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 16, name: "tech_1", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 17, name: "tech_2", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 18, name: "tech_3", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 19, name: "tech_4", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 20, name: "tech_5", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 21, name: "tech_6", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 22, name: "tech_7", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 23, name: "tech_8", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 24, name: "tech_9", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 25, name: "tech_10", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.invoiceId = 0;
        message.customerId = 0;
        message.invoiceDate = "";
        message.jobCompletedDate = "";
        message.customerFirstname = "";
        message.customerLastname = "";
        message.matEquipPo = "";
        message.departmentName = "";
        message.departmentId = 0;
        message.total = 0;
        message.balance = 0;
        message.leadGeneratedBy = 0;
        message.soldBy = 0;
        message.allTechsIds = "";
        message.allTechs = "";
        message.tech1 = "";
        message.tech2 = "";
        message.tech3 = "";
        message.tech4 = "";
        message.tech5 = "";
        message.tech6 = "";
        message.tech7 = "";
        message.tech8 = "";
        message.tech9 = "";
        message.tech10 = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* int32 invoice_id */ 1:
                    message.invoiceId = reader.int32();
                    break;
                case /* int32 customer_id */ 2:
                    message.customerId = reader.int32();
                    break;
                case /* string invoice_date */ 3:
                    message.invoiceDate = reader.string();
                    break;
                case /* string job_completed_date */ 4:
                    message.jobCompletedDate = reader.string();
                    break;
                case /* string customer_firstname */ 5:
                    message.customerFirstname = reader.string();
                    break;
                case /* string customer_lastname */ 6:
                    message.customerLastname = reader.string();
                    break;
                case /* string mat_equip_po */ 7:
                    message.matEquipPo = reader.string();
                    break;
                case /* string department_name */ 8:
                    message.departmentName = reader.string();
                    break;
                case /* int32 department_id */ 9:
                    message.departmentId = reader.int32();
                    break;
                case /* float total */ 10:
                    message.total = reader.float();
                    break;
                case /* float balance */ 11:
                    message.balance = reader.float();
                    break;
                case /* int32 lead_generated_by */ 12:
                    message.leadGeneratedBy = reader.int32();
                    break;
                case /* int32 sold_by */ 13:
                    message.soldBy = reader.int32();
                    break;
                case /* string all_techs_ids */ 14:
                    message.allTechsIds = reader.string();
                    break;
                case /* string all_techs */ 15:
                    message.allTechs = reader.string();
                    break;
                case /* string tech_1 */ 16:
                    message.tech1 = reader.string();
                    break;
                case /* string tech_2 */ 17:
                    message.tech2 = reader.string();
                    break;
                case /* string tech_3 */ 18:
                    message.tech3 = reader.string();
                    break;
                case /* string tech_4 */ 19:
                    message.tech4 = reader.string();
                    break;
                case /* string tech_5 */ 20:
                    message.tech5 = reader.string();
                    break;
                case /* string tech_6 */ 21:
                    message.tech6 = reader.string();
                    break;
                case /* string tech_7 */ 22:
                    message.tech7 = reader.string();
                    break;
                case /* string tech_8 */ 23:
                    message.tech8 = reader.string();
                    break;
                case /* string tech_9 */ 24:
                    message.tech9 = reader.string();
                    break;
                case /* string tech_10 */ 25:
                    message.tech10 = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* int32 invoice_id = 1; */
        if (message.invoiceId !== 0)
            writer.tag(1, WireType.Varint).int32(message.invoiceId);
        /* int32 customer_id = 2; */
        if (message.customerId !== 0)
            writer.tag(2, WireType.Varint).int32(message.customerId);
        /* string invoice_date = 3; */
        if (message.invoiceDate !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.invoiceDate);
        /* string job_completed_date = 4; */
        if (message.jobCompletedDate !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.jobCompletedDate);
        /* string customer_firstname = 5; */
        if (message.customerFirstname !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.customerFirstname);
        /* string customer_lastname = 6; */
        if (message.customerLastname !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.customerLastname);
        /* string mat_equip_po = 7; */
        if (message.matEquipPo !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.matEquipPo);
        /* string department_name = 8; */
        if (message.departmentName !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.departmentName);
        /* int32 department_id = 9; */
        if (message.departmentId !== 0)
            writer.tag(9, WireType.Varint).int32(message.departmentId);
        /* float total = 10; */
        if (message.total !== 0)
            writer.tag(10, WireType.Bit32).float(message.total);
        /* float balance = 11; */
        if (message.balance !== 0)
            writer.tag(11, WireType.Bit32).float(message.balance);
        /* int32 lead_generated_by = 12; */
        if (message.leadGeneratedBy !== 0)
            writer.tag(12, WireType.Varint).int32(message.leadGeneratedBy);
        /* int32 sold_by = 13; */
        if (message.soldBy !== 0)
            writer.tag(13, WireType.Varint).int32(message.soldBy);
        /* string all_techs_ids = 14; */
        if (message.allTechsIds !== "")
            writer.tag(14, WireType.LengthDelimited).string(message.allTechsIds);
        /* string all_techs = 15; */
        if (message.allTechs !== "")
            writer.tag(15, WireType.LengthDelimited).string(message.allTechs);
        /* string tech_1 = 16; */
        if (message.tech1 !== "")
            writer.tag(16, WireType.LengthDelimited).string(message.tech1);
        /* string tech_2 = 17; */
        if (message.tech2 !== "")
            writer.tag(17, WireType.LengthDelimited).string(message.tech2);
        /* string tech_3 = 18; */
        if (message.tech3 !== "")
            writer.tag(18, WireType.LengthDelimited).string(message.tech3);
        /* string tech_4 = 19; */
        if (message.tech4 !== "")
            writer.tag(19, WireType.LengthDelimited).string(message.tech4);
        /* string tech_5 = 20; */
        if (message.tech5 !== "")
            writer.tag(20, WireType.LengthDelimited).string(message.tech5);
        /* string tech_6 = 21; */
        if (message.tech6 !== "")
            writer.tag(21, WireType.LengthDelimited).string(message.tech6);
        /* string tech_7 = 22; */
        if (message.tech7 !== "")
            writer.tag(22, WireType.LengthDelimited).string(message.tech7);
        /* string tech_8 = 23; */
        if (message.tech8 !== "")
            writer.tag(23, WireType.LengthDelimited).string(message.tech8);
        /* string tech_9 = 24; */
        if (message.tech9 !== "")
            writer.tag(24, WireType.LengthDelimited).string(message.tech9);
        /* string tech_10 = 25; */
        if (message.tech10 !== "")
            writer.tag(25, WireType.LengthDelimited).string(message.tech10);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PayoutPerJob
 */
export const PayoutPerJob = new PayoutPerJob$Type();
// @generated message type with reflection information, may provide speed optimized methods
class PayoutPerJobList$Type extends MessageType {
    constructor() {
        super("PayoutPerJobList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => PayoutPerJob },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated PayoutPerJob results */ 1:
                    message.results.push(PayoutPerJob.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated PayoutPerJob results = 1; */
        for (let i = 0; i < message.results.length; i++)
            PayoutPerJob.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message PayoutPerJobList
 */
export const PayoutPerJobList = new PayoutPerJobList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeoffAuditReportLine$Type extends MessageType {
    constructor() {
        super("TimeoffAuditReportLine", [
            { no: 1, name: "user_firstname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "user_lastname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "request_type_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "time_started", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "time_finished", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "duration_hours", kind: "scalar", T: 1 /*ScalarType.DOUBLE*/ },
            { no: 7, name: "admin_firstname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "admin_lastname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "approval_status", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 10, name: "employment_type", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 11, name: "employee_department_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 12, name: "department_name", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.userFirstname = "";
        message.userLastname = "";
        message.requestTypeName = "";
        message.timeStarted = "";
        message.timeFinished = "";
        message.durationHours = 0;
        message.adminFirstname = "";
        message.adminLastname = "";
        message.approvalStatus = "";
        message.employmentType = "";
        message.employeeDepartmentId = 0;
        message.departmentName = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string user_firstname */ 1:
                    message.userFirstname = reader.string();
                    break;
                case /* string user_lastname */ 2:
                    message.userLastname = reader.string();
                    break;
                case /* string request_type_name */ 3:
                    message.requestTypeName = reader.string();
                    break;
                case /* string time_started */ 4:
                    message.timeStarted = reader.string();
                    break;
                case /* string time_finished */ 5:
                    message.timeFinished = reader.string();
                    break;
                case /* double duration_hours */ 6:
                    message.durationHours = reader.double();
                    break;
                case /* string admin_firstname */ 7:
                    message.adminFirstname = reader.string();
                    break;
                case /* string admin_lastname */ 8:
                    message.adminLastname = reader.string();
                    break;
                case /* string approval_status */ 9:
                    message.approvalStatus = reader.string();
                    break;
                case /* string employment_type */ 10:
                    message.employmentType = reader.string();
                    break;
                case /* int32 employee_department_id */ 11:
                    message.employeeDepartmentId = reader.int32();
                    break;
                case /* string department_name */ 12:
                    message.departmentName = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string user_firstname = 1; */
        if (message.userFirstname !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.userFirstname);
        /* string user_lastname = 2; */
        if (message.userLastname !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.userLastname);
        /* string request_type_name = 3; */
        if (message.requestTypeName !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.requestTypeName);
        /* string time_started = 4; */
        if (message.timeStarted !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.timeStarted);
        /* string time_finished = 5; */
        if (message.timeFinished !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.timeFinished);
        /* double duration_hours = 6; */
        if (message.durationHours !== 0)
            writer.tag(6, WireType.Bit64).double(message.durationHours);
        /* string admin_firstname = 7; */
        if (message.adminFirstname !== "")
            writer.tag(7, WireType.LengthDelimited).string(message.adminFirstname);
        /* string admin_lastname = 8; */
        if (message.adminLastname !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.adminLastname);
        /* string approval_status = 9; */
        if (message.approvalStatus !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.approvalStatus);
        /* string employment_type = 10; */
        if (message.employmentType !== "")
            writer.tag(10, WireType.LengthDelimited).string(message.employmentType);
        /* int32 employee_department_id = 11; */
        if (message.employeeDepartmentId !== 0)
            writer.tag(11, WireType.Varint).int32(message.employeeDepartmentId);
        /* string department_name = 12; */
        if (message.departmentName !== "")
            writer.tag(12, WireType.LengthDelimited).string(message.departmentName);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TimeoffAuditReportLine
 */
export const TimeoffAuditReportLine = new TimeoffAuditReportLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class TimeoffAuditReportList$Type extends MessageType {
    constructor() {
        super("TimeoffAuditReportList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => TimeoffAuditReportLine },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated TimeoffAuditReportLine results */ 1:
                    message.results.push(TimeoffAuditReportLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated TimeoffAuditReportLine results = 1; */
        for (let i = 0; i < message.results.length; i++)
            TimeoffAuditReportLine.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message TimeoffAuditReportList
 */
export const TimeoffAuditReportList = new TimeoffAuditReportList$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SystemInstallAnniversaryReportLine$Type extends MessageType {
    constructor() {
        super("SystemInstallAnniversaryReportLine", [
            { no: 1, name: "customer_firstname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "customer_lastname", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "address", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "city", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "state", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "zip", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 7, name: "system_readings_type_id", kind: "scalar", T: 5 /*ScalarType.INT32*/ },
            { no: 8, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 9, name: "install_date", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.customerFirstname = "";
        message.customerLastname = "";
        message.address = "";
        message.city = "";
        message.state = "";
        message.zip = "";
        message.systemReadingsTypeId = 0;
        message.name = "";
        message.installDate = "";
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string customer_firstname */ 1:
                    message.customerFirstname = reader.string();
                    break;
                case /* string customer_lastname */ 2:
                    message.customerLastname = reader.string();
                    break;
                case /* string address */ 3:
                    message.address = reader.string();
                    break;
                case /* string city */ 4:
                    message.city = reader.string();
                    break;
                case /* string state */ 5:
                    message.state = reader.string();
                    break;
                case /* string zip */ 6:
                    message.zip = reader.string();
                    break;
                case /* int32 system_readings_type_id */ 7:
                    message.systemReadingsTypeId = reader.int32();
                    break;
                case /* string name */ 8:
                    message.name = reader.string();
                    break;
                case /* string install_date */ 9:
                    message.installDate = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* string customer_firstname = 1; */
        if (message.customerFirstname !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.customerFirstname);
        /* string customer_lastname = 2; */
        if (message.customerLastname !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.customerLastname);
        /* string address = 3; */
        if (message.address !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.address);
        /* string city = 4; */
        if (message.city !== "")
            writer.tag(4, WireType.LengthDelimited).string(message.city);
        /* string state = 5; */
        if (message.state !== "")
            writer.tag(5, WireType.LengthDelimited).string(message.state);
        /* string zip = 6; */
        if (message.zip !== "")
            writer.tag(6, WireType.LengthDelimited).string(message.zip);
        /* int32 system_readings_type_id = 7; */
        if (message.systemReadingsTypeId !== 0)
            writer.tag(7, WireType.Varint).int32(message.systemReadingsTypeId);
        /* string name = 8; */
        if (message.name !== "")
            writer.tag(8, WireType.LengthDelimited).string(message.name);
        /* string install_date = 9; */
        if (message.installDate !== "")
            writer.tag(9, WireType.LengthDelimited).string(message.installDate);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SystemInstallAnniversaryReportLine
 */
export const SystemInstallAnniversaryReportLine = new SystemInstallAnniversaryReportLine$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SystemInstallAnniversaryReportList$Type extends MessageType {
    constructor() {
        super("SystemInstallAnniversaryReportList", [
            { no: 1, name: "results", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => SystemInstallAnniversaryReportLine },
            { no: 2, name: "total_count", kind: "scalar", T: 5 /*ScalarType.INT32*/ }
        ]);
    }
    create(value) {
        const message = globalThis.Object.create((this.messagePrototype));
        message.results = [];
        message.totalCount = 0;
        if (value !== undefined)
            reflectionMergePartial(this, message, value);
        return message;
    }
    internalBinaryRead(reader, length, options, target) {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated SystemInstallAnniversaryReportLine results */ 1:
                    message.results.push(SystemInstallAnniversaryReportLine.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                case /* int32 total_count */ 2:
                    message.totalCount = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message, writer, options) {
        /* repeated SystemInstallAnniversaryReportLine results = 1; */
        for (let i = 0; i < message.results.length; i++)
            SystemInstallAnniversaryReportLine.internalBinaryWrite(message.results[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* int32 total_count = 2; */
        if (message.totalCount !== 0)
            writer.tag(2, WireType.Varint).int32(message.totalCount);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message SystemInstallAnniversaryReportList
 */
export const SystemInstallAnniversaryReportList = new SystemInstallAnniversaryReportList$Type();
/**
 * @generated ServiceType for protobuf service ReportService
 */
export const ReportService = new ServiceType("ReportService", [
    { name: "GetSpiffReportData", options: {}, I: SpiffReportLine, O: SpiffReport },
    { name: "GetPromptPaymentData", options: {}, I: PromptPaymentReportLine, O: PromptPaymentReport },
    { name: "GetTransactionDumpData", options: {}, I: TransactionReportLine, O: TransactionDumpReport },
    { name: "GetQBOSpreadsheetSyncExport", options: {}, I: TransactionReportLine, O: QBOSpreadsheetSyncExport },
    { name: "SyncQBOTransactions", options: {}, I: TransactionReportLine, O: QBOTransactionSyncReport },
    { name: "SyncQBOBills", options: {}, I: QBOBillSyncRequest, O: QBOBillSyncReport },
    { name: "GetTimeoffReportData", options: {}, I: TimeoffReportRequest, O: TimeoffReport },
    { name: "GetReceiptJournalReport", options: {}, I: ReceiptJournalReportLine, O: ReceiptJournalReport },
    { name: "GetSalesJournalReport", options: {}, I: SalesJournalReportLine, O: SalesJournalReport },
    { name: "GetProcessedReport", options: {}, I: ProcessedReportRequest, O: ProcessedReport },
    { name: "GetCostItemReport", options: {}, I: DateRange, O: CostItemReport },
    { name: "GetBillingAuditReport", options: {}, I: DateRange, O: BillingAuditReport },
    { name: "GetInvoiceJournalReport", options: {}, I: DateRange, O: InvoiceJournalReport },
    { name: "GetJobHoursEmployeeReport", options: {}, I: DateRange, O: JobHoursEmployeeReport },
    { name: "GetDailyJobReport", options: {}, I: Int32, O: DailyJobReport },
    { name: "GetPromptPaymentSummary", options: {}, I: PromptPaymentSummaryRequest, O: PromptPaymentSummaryResponse },
    { name: "CreateEmailsForPromptPayment", options: {}, I: PromptPaymentSummaryRequest, O: String$ },
    { name: "ParseTokenForRequest", options: {}, I: String$, O: PromptPaymentSummaryRequest },
    { name: "GetPromptPaymentDetails", options: {}, I: PromptPaymentSummaryRequest, O: PromptPaymentDetailsResponse },
    { name: "GetPromptPaymentListFinalized", options: {}, I: PromptPaymentListFinalized, O: PromptPaymentListFinalizedResponse },
    { name: "Create", options: {}, I: Report, O: Report },
    { name: "Update", options: {}, I: Report, O: ReportFile },
    { name: "Get", options: {}, I: ReportFile, O: ReportFile },
    { name: "BatchGet", options: {}, I: ReportFile, O: ReportFileList },
    { name: "GetAllReadyToBeProcessedItems", options: {}, I: DateRange, O: CostItemReport },
    { name: "ProcessAllApproved", options: {}, I: DateRange, O: CostItemReport },
    { name: "GetWeeklyEmployeeReport", options: {}, I: WeeklyEmployeeReportRequest, O: TimesheetAuditReportCollection },
    { name: "GetEmployeeKPI", options: {}, I: EmployeeKpiRequest, O: EmployeeKpi },
    { name: "KpiReport", options: {}, I: KpiReportRequest, O: EmployeeKpiList },
    { name: "GetEmployeeHoursRevenue", options: {}, I: EmployeeHoursRevenue, O: EmployeeHoursRevenue },
    { name: "GetBatchEmployeeHoursRevenue", options: {}, I: EmployeeHoursRevenue, O: EmployeeHoursRevenueList },
    { name: "GetTimeOffMetric", options: {}, I: TimeOffMetricRequest, O: TimeOffMetric },
    { name: "GetCallbackMetrics", options: {}, I: Event, O: CallbackMetrics },
    { name: "GetPayoutPerJob", options: {}, I: DateRange, O: PayoutPerJobList },
    { name: "GetTimeoffAuditReport", options: {}, I: DateRange, O: TimeoffAuditReportList },
    { name: "TriggerWeeklyHireTerminationReport", options: {}, I: Empty, O: Bool },
    { name: "GetSystemInstallAnniversaryReport", options: {}, I: DateRange, O: SystemInstallAnniversaryReportList }
]);
